import React, { useState } from "react"
import {
  get,
  concat,
  map,
  isNull,
  nth,
  toString,
  toNumber,
  forEach,
  find,
  includes,
} from "lodash"
import ClassNames from "classnames"

import * as Formatter from "utils/Formatter"
import { APIResponse } from "redux/apis/types"
import store from "redux/store"
import { showSymbol } from "redux/ducks/SymbolDetail"
import {
  formatDisplayPrice,
  getCountryIcon,
  calcChangedRatio,
  checkHasSymbol,
  getNumbersContiguousArray,
  makeSentenceBreakList,
  checkIsBrowser,
  getCapitalMovementsType,
  open_symbol_detail,
  getPriceOrLastClose,
  isHideParam,
} from "utils/util"
import BigNumber from "bignumber.js"
import { DetailSearchStateType } from "components/actions/tool"
import {
  EXCHANGE,
  SECURITY_TYPE,
  REGISTER_EXTENSION,
  INT_MINI,
} from "config/const"
import { ToolTip } from "../components/atoms/text/tooltip"
import { CheckBox } from "components/atoms/input/input"

const currentBrowser = checkIsBrowser()

export const showSymbolDetailModal = (e: Event, row: APIResponse.Res) =>
  store.dispatch(showSymbol(row))
export type CreateColumnsType = Array<{
  title?: Function | string
  className?: Function | string
  format?: Function | string
}>

export const createColumns = (
  title?: Function | string,
  className?: Function | string,
  format?: Function | string,
  displaySp: boolean = false,
  sortable: string | boolean = false,
  row: number = 1,
  col: number = 1
) => {
  return {
    title: title,
    className:
      typeof className === "string" || typeof className === "undefined"
        ? className
        : (row: object) => className(row),
    format:
      typeof format === "string" ? (row: object) => get(row, format) : format,
    displaySp: displaySp,
    sortable: sortable,
    row: row,
    col: col,
  }
}

const RankingTableModels = {
  summarySymbolArea: [
    createColumns(
      "",
      "ranking-cell",
      (data: object) => get(data, "Rank", ""),
      false,
      "Rank"
    ),
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <>
            <span>コード</span>
            <span>{""}</span>
          </>
        ) : (
          "コード"
        ),
      "code-cell",
      (data: object) => Formatter.symbol(data),
      false,
      "Symbol"
    ),
    createColumns(
      (data: object) => {
        return get(data, "variableTitle") || "銘柄"
      },
      "symbol-name-cell",
      (data: object) => (
        <div>
          <span className="group-cell-code isSP">
            {get(data, "Symbol", "")}
          </span>
          <span className="ellipsis-text">
            {get(data, "NameS", "") || get(data, "Name", "")}
          </span>
        </div>
      )
    ),
  ],
  detailSymbolArea: [
    createColumns(
      "",
      "ranking-cell",
      (data: object) => get(data, "Rank", ""),
      false,
      "Rank"
    ),
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>{get(data, "variableTitle") || "銘柄"}</span>
            {get(data, "sortTarget.target") === "Symbol" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "Symbol" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          get(data, "variableTitle") || "銘柄"
        ),
      "symbol-name-cell",
      (data: object) => (
        <div>
          {!!get(data, "SecurityType") && (
            <span className="group-cell-code ellipsis-text">
              {Formatter.symbol(data)}
            </span>
          )}
          <span className="ellipsis-text">
            {get(data, "NameS", "") || get(data, "Name", "")}
          </span>
        </div>
      ),
      false,
      "Symbol"
    ),
  ],
  rankingBase: [
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>現在値</span>
            {get(data, "sortTarget.target") === "Price" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "Price" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "現在値"
        ),
      "currency-price-cell",
      (data: object) =>
        Formatter.number(get(data, "Price"), get(data, "NumberOfDecimals")),
      false,
      "Price"
    ),
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>前日比 (%)</span>
            {get(data, "sortTarget.target") === "ChangedRatio" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "ChangedRatio" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "前日比 (%)"
        ),
      (data: object) =>
        get(data, "selectedRankingType") === "priceIncreaseRate"
          ? "changed-ratio-cell current-target"
          : "changed-ratio-cell",
      (data: object) => (
        <div className="liquid-row">
          <div
            className={ClassNames(
              "liquid-item change-price-value",
              Formatter.upDown(get(data, "ChangedPrice"))
            )}
          >
            {Formatter.number(
              get(data, "ChangedPrice"),
              get(data, "NumberOfDecimals"),
              "floor",
              true
            )}
          </div>
          <div className="liquid-item change-ratio-value">
            (
            <span
              className={ClassNames(
                Formatter.upDown(get(data, "ChangedRatio"))
              )}
            >
              {Formatter.number(get(data, "ChangedRatio"), 2, "floor", true)}
            </span>
            <span className="unit"> %</span>)
          </div>
        </div>
      ),
      false,
      "ChangedRatio"
    ),
  ],
  price: [
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>売買代金</span>
            {get(data, "sortTarget.target") === "TradValue" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "TradValue" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "売買代金"
        ),
      (data: object) =>
        get(data, "selectedRankingType") === "trade"
          ? "trading-value-cell current-target"
          : "trading-value-cell",
      (data: object) => (
        <>
          {Formatter.number(get(data, "TradValue"))}
          <span className="unit">百万</span>
        </>
      ),
      false,
      "TradValue"
    ),
  ],
  priceIncrease: [
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>急増率</span>
            {get(data, "sortTarget.target") === "EstrangeFromTradValue" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "EstrangeFromTradValue" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "急増率"
        ),
      (data: object) =>
        get(data, "selectedRankingType") === "trade"
          ? "trading-value-cell current-target"
          : "trading-value-cell",
      (data: object) => (
        <>
          {Formatter.setNumber(data, "EstrangeFromTradValue")}
          <span className="unit">％</span>
        </>
      ),
      false,
      "EstrangeFromTradValue"
    ),
  ],
  trustBuy: [
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>買残</span>
            {get(data, "sortTarget.target") === "MarginBuyQty" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "MarginBuyQty" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "買残"
        ),
      (data: object) =>
        get(data, "selectedRankingType") === "trustBuy"
          ? "currency-price-cell current-target"
          : "currency-price-cell",
      (data: object) => Formatter.number(get(data, "MarginBuyQty")),
      false,
      "MarginBuyQty"
    ),
  ],
  trustSell: [
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>売残</span>
            {get(data, "sortTarget.target") === "MarginSellQty" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "MarginSellQty" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "売残"
        ),
      (data: object) =>
        get(data, "selectedRankingType") === "trustSell"
          ? "currency-price-cell current-target"
          : "currency-price-cell",
      (data: object) => Formatter.number(get(data, "MarginSellQty")),
      false,
      "MarginSellQty"
    ),
  ],

  trustRate: [
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>倍率(倍)</span>
            {get(data, "sortTarget.target") === "MarginRatio" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "MarginRatio" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "倍率(倍)"
        ),
      (data: object) =>
        get(data, "selectedRankingType") === "trustRate"
          ? "currency-price-cell current-target"
          : "currency-price-cell",
      (data: object) => <>{Formatter.number(get(data, "MarginRatio"), 2)}</>,
      false,
      "MarginRatio"
    ),
  ],
  volume: [
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>出来高</span>
            {get(data, "sortTarget.target") === "TradVolume" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "TradVolume" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "出来高"
        ),
      (data: object) =>
        get(data, "selectedRankingType") === "price"
          ? "volume-cell current-target"
          : "volume-cell",
      //ランキングの出来高はAPIから1000除算された状態で来る。クライアントで1000乗算し対応。
      (data: object) => Formatter.number(get(data, "TradVolume") * 1000),
      false,
      "TradVolume"
    ),
  ],
  volumeIncrease: [
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>急増率</span>
            {get(data, "sortTarget.target") === "EstrangeFromTradVolume" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "EstrangeFromTradVolume" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "急増率"
        ),
      (data: object) =>
        get(data, "selectedRankingType") === "price"
          ? "volume-cell current-target"
          : "volume-cell",
      (data: object) => (
        <>
          {Formatter.number(get(data, "EstrangeFromTradVolume"))}
          <span className="unit">％</span>
        </>
      ),
      false,
      "EstrangeFromTradVolume"
    ),
  ],
  detailInfo: [
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>始値</span>
            {get(data, "sortTarget.target") === "OpenPrice" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "OpenPrice" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "始値"
        ),
      "ohlc-cell",
      (data: object) =>
        Formatter.number(get(data, "OpenPrice"), get(data, "NumberOfDecimals")),
      false,
      "OpenPrice"
    ),
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>高値</span>
            {get(data, "sortTarget.target") === "HighPrice" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "HighPrice" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "高値"
        ),
      "ohlc-cell",
      (data: object) =>
        Formatter.number(get(data, "HighPrice"), get(data, "NumberOfDecimals")),
      false,
      "HighPrice"
    ),
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>安値</span>
            {get(data, "sortTarget.target") === "LowPrice" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "LowPrice" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "安値"
        ),
      "ohlc-cell",
      (data: object) =>
        Formatter.number(get(data, "LowPrice"), get(data, "NumberOfDecimals")),
      false,
      "LowPrice"
    ),
    createColumns(
      (data: object) =>
        !!get(data, "onSort") ? (
          <div className="sort-area">
            <span>前終</span>
            {get(data, "sortTarget.target") === "LastClose" &&
              get(data, "sortTarget.type") === "desc" && (
                <i className="material-icons sort-icon">keyboard_arrow_up</i>
              )}
            {get(data, "sortTarget.target") === "LastClose" &&
              get(data, "sortTarget.type") === "asc" && (
                <i className="material-icons sort-icon">keyboard_arrow_down</i>
              )}
          </div>
        ) : (
          "前終"
        ),
      "volume-cell",
      (data: object) =>
        Formatter.number(
          new BigNumber(get(data, "Price"))
            .minus(get(data, "ChangedPrice"))
            .toNumber(),
          get(data, "NumberOfDecimals")
        ),
      false,
      "LastClose"
    ),
  ],
  marketPrice: [
    createColumns("時価総額", "currency-price-cell", (data: object) => (
      <>
        {Formatter.setNumber(data, "TotalMarketValue")}
        <span className="unit">百万</span>
      </>
    )),
  ],
  time: [
    createColumns("更新", "time-cell", (data: object) =>
      Formatter.date(get(data, "PriceTime"), "HH:mm")
    ),
  ],
}

const ScreeningCommonParts = [
  createColumns("コード", "code-cell", (data: object) => get(data, "Symbol")),
  createColumns("銘柄", "symbol-name-cell test", (data: object) => (
    <span className="symbol-name ellipsis-text">
      {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
    </span>
  )),
  createColumns("市場", "market-cell", (data: object) => {
    const securityType = get(data, "SecurityType")
    const exchange = get(data, "Exchange")
    return securityType === SECURITY_TYPE.Equity.id
      ? Formatter.divisionName(data, true)
      : get(find(REGISTER_EXTENSION, { Exchange: exchange }), "extension")
  }),
  createColumns("前日終値", "last-close-cell", (data: object) =>
    Formatter.number(get(data, "LastClose"), get(data, "NumberOfDecimals"))
  ),
  createColumns("騰落率", "changed-ratio-cell", (data: object) => (
    <div className="liquid-row">
      <div className="liquid-item change-ratio-value">
        <span className={Formatter.upDown(get(data, "ChangedRatio"))}>
          {Formatter.number(get(data, "ChangedRatio"), 2, "floor", true)}
        </span>
        <span className="unit"> %</span>
      </div>
    </div>
  )),
  createColumns("為替レート", "price-cell", (data: object) =>
    get(data, "SecurityType") === SECURITY_TYPE.Equity.id
      ? "-"
      : Formatter.number(get(data, "ExRateYen"), 2)
  ),
]

export const tableColumns = {
  index: {
    summary: [
      createColumns("指数・指標", "index-cell", (row: object) => {
        const icon = getCountryIcon(row)
        return (
          <div className="index-name-row">
            <i className={ClassNames("icon-solid ", icon)} />
            <span className="index-name ellipsis-text">
              {get(row, "SymbolNameS", "") || get(row, "SymbolName", "")}
            </span>
          </div>
        )
      }),
      createColumns("現在値", "currency-price-cell", (row: object) => (
        <div className="liquid-row">
          <div className="currency-price-value liquid-item">
            {get(row, "Exchange") === EXCHANGE.PIR.id
              ? get(row, "Price")
              : Formatter.number(
                  get(row, "Price"),
                  get(row, "NumberOfDecimals")
                )}
          </div>
          <div className="time-col liquid-item">
            {Formatter.date(get(row, "PriceTime"), "MM/DD HH:mm")}
          </div>
        </div>
      )),
      createColumns("前日比 (%)", "changed-price-cell", (row: object) => {
        const changedPrice = new BigNumber(get(row, "Price"))
          .minus(get(row, "LastClose"))
          .toNumber()
        const changedRatio = calcChangedRatio({
          price: get(row, "Price"),
          lastClose: get(row, "LastClose"),
        })
        return (
          <div className="liquid-row">
            <div
              className={ClassNames(
                "change-price-value liquid-item",
                Formatter.upDown(changedPrice)
              )}
            >
              {Formatter.number(
                changedPrice,
                get(row, "NumberOfDecimals"),
                "floor",
                true
              )}
            </div>
            <div className="change-ratio-value liquid-item">
              (
              <span className={ClassNames(Formatter.upDown(changedRatio))}>
                {Formatter.number(changedRatio, 2, "floor", true)}
              </span>
              <span className="unit">%</span>)
            </div>
          </div>
        )
      }),
    ],
    //summaryの更新カラムあり版
    //TODO:2020/05/11 templates/templates.stories.tsx でのみ使用中
    domesticSummary: [
      createColumns("指数・指標", "index-cell", (row: object) => (
        <span className="index-name ellipsis-text">
          {get(row, "SymbolName")}
        </span>
      )),
      createColumns("現在値", "currency-price-cell", (row: object) =>
        formatDisplayPrice(row)
      ),
      createColumns("前日比 (%)", "changed-price-cell", (row: object) => {
        const changedPrice = new BigNumber(get(row, "Price"))
          .minus(get(row, "LastClose"))
          .toNumber()
        const changedRatio = calcChangedRatio({
          price: get(row, "Price"),
          lastClose: get(row, "LastClose"),
        })

        return (
          <div className="liquid-row">
            <div
              className={ClassNames(
                "change-price-value liquid-item",
                Formatter.upDown(changedPrice)
              )}
            >
              {Formatter.number(
                changedPrice,
                get(row, "NumberOfDecimals"),
                "floor",
                true
              )}
            </div>
            <div className={ClassNames("change-ratio-value liquid-item")}>
              (
              <span className={ClassNames(Formatter.upDown(changedRatio))}>
                {Formatter.number(changedRatio, 2, "floor", true)}
              </span>
              <span className="unit">%</span>)
            </div>
          </div>
        )
      }),
      createColumns("更新", "date-time-cell", (row: object) =>
        Formatter.date(get(row, "PriceTime"), "MM/DD HH:mm")
      ),
    ],
    currencySummary: [
      createColumns("通貨", "index-cell", (row: object) => {
        const icon = getCountryIcon(row)
        return (
          <div className="index-name-row">
            <i className={ClassNames("icon-solid ", icon)} />
            <div className="index-name ellipsis-text">
              {get(row, "SymbolNameS", "") || get(row, "SymbolName", "")}
            </div>
          </div>
        )
      }),
      createColumns("現在値", "currency-price-cell", (row: object) => {
        const [_price, _priceTime] = getPriceOrLastClose(row)
        return (
          <div className="liquid-row">
            <div className="currency-price-value liquid-item">
              {Formatter.number(_price, get(row, "NumberOfDecimals"))}
            </div>
            <div className="time-col liquid-item">
              {Formatter.date(_priceTime, "MM/DD HH:mm")}
            </div>
          </div>
        )
      }),
      createColumns("前日比 (%)", "changed-price-cell", (row: object) => {
        const changedPrice = new BigNumber(get(row, "Price"))
          .minus(get(row, "LastClose"))
          .toNumber()
        const changedRatio = calcChangedRatio({
          price: get(row, "Price"),
          lastClose: get(row, "LastClose"),
        })
        return (
          <div className="liquid-row">
            <div
              className={ClassNames(
                "change-price-value liquid-item",
                Formatter.upDown(changedPrice)
              )}
            >
              {Formatter.number(
                changedPrice,
                get(row, "NumberOfDecimals"),
                "floor",
                true
              )}
            </div>
            <div className="change-ratio-value liquid-item">
              (
              <span className={ClassNames(Formatter.upDown(changedRatio))}>
                {Formatter.number(changedRatio, 2, "floor", true)}
              </span>
              <span className="unit">%</span>)
            </div>
          </div>
        )
      }),
    ],
    interest: [
      createColumns("主要金利", "bank-cell", (row: object) => {
        const icon = getCountryIcon(row)
        return (
          <div className="index-name-row">
            <i className={ClassNames("icon-solid ", icon)} />
            <div className="index-name ellipsis-text">
              {get(row, "SymbolNameS", "") || get(row, "SymbolName", "")}
            </div>
          </div>
        )
      }),
      createColumns("利回り", "yield-cell", (row: object) => {
        const [_price, _priceTime] = getPriceOrLastClose(row)
        return (
          <div className="liquid-row">
            <div className="currency-price-value liquid-item">
              {Formatter.number(_price, get(row, "NumberOfDecimals"))}
            </div>
            <div className="time-col liquid-item">
              {Formatter.date(_priceTime, "MM/DD HH:mm")}
            </div>
          </div>
        )
      }),
      createColumns("利回比", "yield-ratio-cell", (row: object) => {
        const yieldRatio = new BigNumber(get(row, "Price"))
          .minus(get(row, "LastClose"))
          .toNumber()
        return (
          <div
            className={ClassNames(
              "change-price-value liquid-item",
              Formatter.upDown(yieldRatio)
            )}
          >
            {Formatter.number(
              yieldRatio,
              get(row, "NumberOfDecimals"),
              "floor",
              true
            )}
          </div>
        )
      }),
    ],
    mainList: [
      createColumns("指数・指標", "index-cell", (data: object) => {
        const icon = getCountryIcon(data)
        return (
          <div className="index-name-row">
            <i className={ClassNames("icon-solid ", icon)} />
            <div className="index-name ellipsis-text">
              {get(data, "SymbolName")}
            </div>
          </div>
        )
      }),
      createColumns("現在値", "currency-price-cell", (data: object) =>
        Formatter.number(get(data, "Price"), get(data, "NumberOfDecimals"))
      ),
      createColumns("前日比 (%)", "changed-price-cell", (data: object) => {
        const changedPrice = new BigNumber(get(data, "Price"))
          .minus(get(data, "LastClose"))
          .toNumber()
        const changedRatio = calcChangedRatio({
          price: get(data, "Price"),
          lastClose: get(data, "LastClose"),
        })
        return (
          <div className="liquid-row">
            <div
              className={ClassNames(
                "liquid-item change-price-value",
                Formatter.upDown(changedPrice)
              )}
            >
              {Formatter.number(
                changedPrice,
                get(data, "NumberOfDecimals"),
                "floor",
                true
              )}
            </div>
            <div
              className={ClassNames(
                "liquid-item change-ratio-value",
                Formatter.upDown(changedRatio)
              )}
            >
              (
              <span className={Formatter.upDown(changedRatio)}>
                {Formatter.number(changedRatio, 2, "floor", true)}
              </span>
            </div>
            <span className="unit">%</span>)
          </div>
        )
      }),
      createColumns("更新", "date-time-cell", (data: object) =>
        Formatter.date(get(data, "PriceTime"), "MM/DD HH:mm")
      ),
    ],
    industry: {
      industrySummary: (targetInfo: string) => [
        createColumns("", "mark-cell", (row: object, i: number) => i + 1),
        createColumns("業種", "industry-cell", (row: object) => (
          <span className="ellipsis-text">{get(row, "SymbolName")}</span>
        )),
        createColumns("現在値", "currency-price-cell", (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item currency-price-value">
              {Formatter.number(
                get(row, "Price"),
                get(row, "NumberOfDecimals")
              )}
            </div>
            <div className="liquid-item time-col">
              {Formatter.date(get(row, "PriceTime"), "MM/DD HH:mm")}
            </div>
          </div>
        )),
        createColumns(targetInfo, "changed-price-cell", (row: object) => {
          const changedRatio = calcChangedRatio({
            price: get(row, "Price"),
            lastClose: get(row, "LastClose"),
          })
          return (
            <div className="liquid-row">
              <div className="liquid-item change-ratio-value">
                <span className={ClassNames(Formatter.upDown(changedRatio))}>
                  {Formatter.number(changedRatio, 2, "floor", true)}
                </span>
                <span className="unit">%</span>
              </div>
            </div>
          )
        }),
      ],
      industry: [
        createColumns("", "mark-cell", (row: object, i: number) => i + 1),
        createColumns("業種", "industry-cell", (row: object) => (
          <span className="ellipsis-text">{get(row, "SymbolName")}</span>
        )),
        createColumns("現在値", "currency-price-cell", (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item currency-price-value">
              {Formatter.number(
                get(row, "Price"),
                get(row, "NumberOfDecimals")
              )}
            </div>
            <div className="liquid-item time-col">
              {Formatter.date(get(row, "PriceTime"), "MM/DD hh:mm")}
            </div>
          </div>
        )),
        createColumns("前日比 (%)", "changed-price-cell", (row: object) => {
          const changedPrice = new BigNumber(get(row, "Price"))
            .minus(get(row, "LastClose"))
            .toNumber()
          const changedRatio = calcChangedRatio({
            price: get(row, "Price"),
            lastClose: get(row, "LastClose"),
          })
          return (
            <div className="liquid-row">
              <div
                className={ClassNames(
                  "liquid-item change-price-value",
                  Formatter.upDown(changedPrice)
                )}
              >
                {Formatter.number(
                  changedPrice,
                  get(row, "NumberOfDecimals"),
                  "floor",
                  true
                )}
              </div>
              <div className="liquid-item change-ratio-value">
                (
                <span className={ClassNames(Formatter.upDown(changedRatio))}>
                  {Formatter.number(changedRatio, 2, "floor", true)}
                </span>
                <span className="unit">%</span>)
              </div>
            </div>
          )
        }),
      ],
      relate: [
        createColumns("構成銘柄", "symbol-name-cell", (row: object) => (
          <div>
            <div className="code-market-group">
              <span className="code-cell">{get(row, "Symbol")}</span>
              <span className="market-cell">
                {get(row, "ExchangeName") + get(row, "DivisionName")}
              </span>
            </div>
            <span className="ellipsis-text">
              {get(row, "SymbolNameS") || get(row, "SymbolName")}
            </span>
          </div>
        )),
        createColumns("現在値", "currency-price-cell", (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item currency-price-value">
              {Formatter.number(
                get(row, "Price"),
                get(row, "NumberOfDecimals")
              )}
            </div>
            <div className="liquid-item time-col">
              {Formatter.date(get(row, "PriceTime"), "MM/DD hh:mm")}
            </div>
          </div>
        )),
        createColumns("前日比 (%)", "changed-price-cell", (row: object) => {
          return (
            <div className="liquid-row">
              <div
                className={ClassNames(
                  "liquid-item change-price-value",
                  Formatter.upDown(get(row, "ChangedPrice"))
                )}
              >
                {Formatter.number(
                  get(row, "ChangedPrice"),
                  get(row, "NumberOfDecimals"),
                  "floor",
                  true
                )}
              </div>
              <div className="liquid-item change-ratio-value">
                (
                <span
                  className={ClassNames(
                    Formatter.upDown(get(row, "ChangedRatio"))
                  )}
                >
                  {Formatter.number(get(row, "ChangedRatio"), 2, "floor", true)}
                </span>
                <span className="unit">%</span>)
              </div>
            </div>
          )
        }),
      ],
    },
  },
  economics: {
    index: [
      createColumns("国", "country-cell", (row: object) => {
        const icon = getCountryIcon(row)
        return <i className={ClassNames("icon-solid ", icon)} />
      }),
      createColumns("指標", "index-cell", (row: object) => (
        <>
          <div className="index-title-col index-name ellipsis-text">
            {get(row, "DisplayName")}
          </div>
          <div className="control-row">
            <div className="rate-col">
              {map(
                getNumbersContiguousArray(get(row, "Importance")),
                (num: number, i: number) => {
                  return (
                    <div className="material-icons rate-importance" key={i}>
                      {get(row, "Importance") >= num && "star"}
                    </div>
                  )
                }
              )}
            </div>
            <div className="time-col">
              {Formatter.date(get(row, "AnnouncedAt"), "MM/DD HH:mm")}
            </div>
          </div>
        </>
      )),
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item term-month-value">対象期</div>
          </div>
        ),
        "target-term-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item term-month-value">
              {get(row, "DisplayTargetDate")}
            </div>
          </div>
        )
      ),
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item announced-value">発表数値</div>
          </div>
        ),
        "announced-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item announced-value">
              {get(row, "ActualText")}
            </div>
          </div>
        )
      ),
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item survey-forecast-value">調査予想</div>
          </div>
        ),
        "survey-forecast-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item survey-forecast-value">
              {get(row, "SurveyText")}
            </div>
          </div>
        )
      ),
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item changed-value">前回値</div>
            {/*<div className="liquid-item importance-value">重要度</div>*/}
          </div>
        ),
        "changed-value-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item changed-value">
              {get(row, "RevisedPriorText")}
            </div>
          </div>
        )
      ),
    ],
    header: [
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item term-month-value">対象期</div>
          </div>
        ),
        "target-term-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item">{get(row, "DisplayTargetDate")}</div>
          </div>
        )
      ),
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item announced-value">発表数値</div>
          </div>
        ),
        "announced-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item">{get(row, "ActualText")}</div>
          </div>
        )
      ),
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item survey-forecast-value">調査予想</div>
          </div>
        ),
        "survey-forecast-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item">{get(row, "SurveyText")}</div>
          </div>
        )
      ),
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item">前回値</div>
          </div>
        ),
        "changed-value-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item">{get(row, "RevisedPriorText")}</div>
          </div>
        )
      ),
    ],
    domesticIndex: (info: string) => [
      createColumns(() => <>{info}JST</>, "date-time-cell", (row: object) =>
        Formatter.date(get(row, "AnnouncedAt"), "MM/DD HH:mm")
      ),
      createColumns("指標", "index-cell", (row: object) => (
        <>
          <div className="index-title-col index-name ellipsis-text">
            {get(row, "DisplayName")}
          </div>
          <div className="control-row">
            <div className="rate-col">
              {map(
                getNumbersContiguousArray(get(row, "Importance")),
                (num: number) => {
                  return (
                    <div className="material-icons rate-importance">
                      {get(row, "Importance") >= num && "star"}
                    </div>
                  )
                }
              )}
            </div>
            <div className="time-col">
              {Formatter.date(get(row, "AnnouncedAt"), "MM/DD HH:mm")}
            </div>
          </div>
        </>
      )),
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item term-month-value">対象期</div>
          </div>
        ),
        "target-term-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item term-month-value">
              {get(row, "DisplayTargetDate")}
            </div>
          </div>
        )
      ),
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item announced-value">発表数値</div>
          </div>
        ),
        "announced-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item announced-value">
              {get(row, "ActualText")}
            </div>
          </div>
        )
      ),
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item survey-forecast-value">調査予想</div>
          </div>
        ),
        "survey-forecast-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item survey-forecast-value">
              {get(row, "SurveyText")}
            </div>
          </div>
        )
      ),
      createColumns(
        () => (
          <div className="liquid-row">
            <div className="liquid-item changed-value">前回値</div>
          </div>
        ),
        "changed-value-cell",
        (row: object) => (
          <div className="liquid-row">
            <div className="liquid-item changed-value">
              {get(row, "RevisedPriorText")}
            </div>
          </div>
        )
      ),
    ],
    sp: {
      header: [
        (row: object) => {
          const icon = getCountryIcon(row)
          return (
            <div className="title-cell">
              <i className={ClassNames("icon-solid ", icon)} />
            </div>
          )
        },
        (row: object) => {
          return (
            <div className="title-cell symbol-name">
              {get(row, "DisplayName")}
            </div>
          )
        },
        (row: object) => {
          return (
            <div className="title-cell">
              <div className="rate-col">
                {map(
                  getNumbersContiguousArray(get(row, "Importance")),
                  (num: number) => {
                    return (
                      <div className="material-icons rate-importance">
                        {get(row, "Importance") >= num && "star"}
                      </div>
                    )
                  }
                )}
              </div>
              <div className="time-col">
                {Formatter.date(get(row, "AnnouncedAt"), "MM/DD HH:mm")}
              </div>
            </div>
          )
        },
      ],
      body: [
        {
          title: "対象期",
          value: (row: object) => {
            return (
              <div className="liquid-row">
                <div className="liquid-item term-month-value">
                  {get(row, "DisplayTargetDate")}
                </div>
              </div>
            )
          },
        },
        {
          title: "発表数値",
          value: (row: object) => {
            return (
              <div className="liquid-row">
                <div className="liquid-item announced-value">
                  {get(row, "ActualText")}
                </div>
              </div>
            )
          },
        },
        {
          title: "調査予想",
          value: (row: object) => {
            return (
              <div className="liquid-row">
                <div className="liquid-item survey-forecast-value">
                  {get(row, "SurveyText")}
                </div>
              </div>
            )
          },
        },
        {
          title: "前回値",
          value: (row: object) => {
            return (
              <div className="liquid-row">
                <div className="liquid-item changed-value">
                  {get(row, "RevisedPriorText")}
                </div>
              </div>
            )
          },
        },
      ],
    },
  },
  future: [
    createColumns("限月", "contract-month-cell", (row: object) =>
      Formatter.date(
        `${get(row, "DeliveryYear", "")}${get(row, "DeliveryMonth", "")}`,
        "YY年MM月"
      )
    ),
    createColumns("現在値", "currency-price-cell", (row: object) => {
      return (
        <div>
          <div>
            {Formatter.number(
              get(row, "Price", "-"),
              get(row, "NumberOfDecimals"),
              "floor"
            )}
          </div>
          <div className="time-col liquid-item">
            {Formatter.date(get(row, "PriceTime"), "MM/DD HH:mm")}
          </div>
        </div>
      )
    }),
    createColumns("前日比 (%)", "changed-price-cell", (data: object) => {
      const changedPrice = new BigNumber(get(data, "Price"))
        .minus(get(data, "LastClose"))
        .toNumber()
      const changedRatio = calcChangedRatio({
        price: get(data, "Price"),
        lastClose: get(data, "LastClose"),
      })
      return (
        <div className="liquid-row">
          <div
            className={ClassNames(
              "change-price-value liquid-item",
              Formatter.upDown(changedPrice)
            )}
          >
            {Formatter.number(
              changedPrice,
              get(data, "NumberOfDecimals"),
              "floor",
              true
            )}
          </div>
          <div className="change-ratio-value liquid-item">
            (
            <span className={ClassNames(Formatter.upDown(changedRatio))}>
              {Formatter.number(changedRatio, 2, "floor", true)}
            </span>
            <span className="unit">%</span>)
          </div>
        </div>
      )
    }),
    createColumns("売気配(数量)", "kehai-cell", (row: object) => {
      return (
        <div>
          <div>
            {Formatter.number(
              get(row, "Ask", null),
              get(row, "NumberOfDecimals")
            )}
          </div>
          <div>({Formatter.number(get(row, "AskVolume", null))})</div>
        </div>
      )
    }),
    createColumns("買気配(数量)", "kehai-cell", (row: object) => {
      return (
        <div>
          <div>
            {Formatter.number(
              get(row, "Bid", null),
              get(row, "NumberOfDecimals")
            )}
          </div>
          <div>({Formatter.number(get(row, "BidVolume", null))})</div>
        </div>
      )
    }),
  ],
  sp_future: [
    createColumns("限月", "contract-month-cell", (row: object) =>
      Formatter.date(
        `${get(row, "DeliveryYear", "")}${get(row, "DeliveryMonth", "")}`,
        "YY年MM月"
      )
    ),
    createColumns("現在値", "currency-price-cell", (row: object) => {
      return (
        <div>
          <div>
            {Formatter.number(
              get(row, "Price", "-"),
              get(row, "NumberOfDecimals"),
              "floor"
            )}
          </div>
          <div className="time-col liquid-item">
            {Formatter.date(get(row, "PriceTime"), "MM/DD HH:mm")}
          </div>
        </div>
      )
    }),
    createColumns("前日比 (%)", "changed-price-cell", (data: object) => {
      const changedPrice = new BigNumber(get(data, "Price"))
        .minus(get(data, "LastClose"))
        .toNumber()
      const changedRatio = calcChangedRatio({
        price: get(data, "Price"),
        lastClose: get(data, "LastClose"),
      })
      return (
        <div className="liquid-row">
          <div
            className={ClassNames(
              "change-price-value liquid-item",
              Formatter.upDown(changedPrice)
            )}
          >
            {Formatter.number(
              changedPrice,
              get(data, "NumberOfDecimals"),
              "floor",
              true
            )}
          </div>
          <div className="change-ratio-value liquid-item">
            (
            <span className={ClassNames(Formatter.upDown(changedRatio))}>
              {Formatter.number(changedRatio, 2, "floor", true)}
            </span>
            <span className="unit">%</span>)
          </div>
        </div>
      )
    }),
  ],
  nikkei: [
    createColumns("コード", "code-cell", (data: object) =>
      get(data, "Symbol", "")
    ),
    createColumns("銘柄", "symbol-name-cell", (data: object) => (
      <div className="ellipsis-text">
        {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
      </div>
    )),
    createColumns("現在値", "currency-price-cell ", (data: object) => (
      <div className="amount-row">
        <div className="currency-price-value">
          {Formatter.number(
            get(data, "Price", null),
            get(data, "NumberOfDecimals")
          )}
        </div>
        <div className="time-col liquid-item">
          {Formatter.date(get(data, "PriceTime"), "HH:mm")}
        </div>
      </div>
    )),
    createColumns("前日比 (%)", "changed-ratio-cell", (data: object) => {
      return (
        <div className="liquid-row">
          <div
            className={ClassNames(
              "change-price-value liquid-item",
              Formatter.upDown(get(data, "ChangedPrice"))
            )}
          >
            {Formatter.number(
              get(data, "ChangedPrice"),
              get(data, "NumberOfDecimals"),
              "floor",
              true
            )}
          </div>
          <div className="change-ratio-value liquid-item">
            (
            <span
              className={ClassNames(
                Formatter.upDown(get(data, "ChangedRatio"))
              )}
            >
              {Formatter.number(get(data, "ChangedRatio"), 2, "floor", true)}
            </span>
            <span className="unit">%</span>)
          </div>
        </div>
      )
    }),
    createColumns("出来高", "volume-cell", (data: object) =>
      Formatter.number(get(data, "TradVolume"))
    ),
  ],
  nikkeiSp: [
    createColumns("銘柄", "symbol-name-cell", (data: object) => (
      <>
        <div className="code-cell">{get(data, "Symbol", "")}</div>
        <div className="ellipsis-text">
          {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
        </div>
      </>
    )),
    createColumns("現在値", "currency-price-cell ", (data: object) => (
      <div className="amount-row">
        <div className="currency-price-value">
          {Formatter.number(
            get(data, "Price", null),
            get(data, "NumberOfDecimals")
          )}
        </div>
        <div className="time-col liquid-item">
          {Formatter.date(get(data, "PriceTime"), "HH:mm")}
        </div>
      </div>
    )),
    createColumns("前日比 (%)", "changed-ratio-cell", (data: object) => {
      return (
        <div className="liquid-row">
          <div
            className={ClassNames(
              "change-price-value liquid-item",
              Formatter.upDown(get(data, "ChangedPrice"))
            )}
          >
            {Formatter.number(
              get(data, "ChangedPrice"),
              get(data, "NumberOfDecimals"),
              "floor",
              true
            )}
          </div>
          <div className="change-ratio-value liquid-item">
            (
            <span
              className={ClassNames(
                Formatter.upDown(get(data, "ChangedRatio"))
              )}
            >
              {Formatter.number(get(data, "ChangedRatio"), 2, "floor", true)}
            </span>
            <span className="unit">%</span>)
          </div>
        </div>
      )
    }),
    createColumns("出来高", "volume-cell", (data: object) =>
      Formatter.number(get(data, "TradVolume"))
    ),
  ],
  ranking: {
    ranking: (targetInfo: string) => [
      createColumns("", "ranking-cell", (data: object) =>
        get(data, "Rank", "")
      ),
      createColumns("コード", "code-cell", (data: object) =>
        Formatter.symbol(data)
      ),
      createColumns("銘柄", "symbol-name-cell", (data: object) => (
        <div className="ellipsis-text">
          {get(data, "NameS", "") || get(data, "Name", "")}
        </div>
      )),
      createColumns("現在値", "currency-price-cell", (data: object) =>
        Formatter.number(get(data, "Price"), get(data, "NumberOfDecimals"))
      ),
      createColumns(targetInfo, "changed-ratio-cell", (data: object) => (
        <div className="liquid-row">
          <div className="liquid-item change-ratio-value">
            <span
              className={ClassNames(
                Formatter.upDown(get(data, "ChangedRatio"))
              )}
            >
              {Formatter.number(get(data, "ChangedRatio"), 2, "floor", true)}
            </span>
            <span className="unit"> %</span>
          </div>
        </div>
      )),
    ],
    rankingSp: (targetInfo: string) => [
      createColumns("", "ranking-cell", (data: object) =>
        get(data, "Rank", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (data: object) => (
        <div>
          <div>{Formatter.symbol(data)}</div>
          <div className="ellipsis-text">
            {get(data, "NameS", "") || get(data, "Name", "")}
          </div>
        </div>
      )),
      createColumns("現在値", "currency-price-cell", (data: object) =>
        Formatter.number(get(data, "Price"), get(data, "NumberOfDecimals"))
      ),
      createColumns(targetInfo, "changed-ratio-cell", (data: object) => (
        <div className="liquid-row">
          <div className="liquid-item change-ratio-value">
            <span
              className={ClassNames(
                Formatter.upDown(get(data, "ChangedRatio"))
              )}
            >
              {Formatter.number(get(data, "ChangedRatio"), 2, "floor", true)}
            </span>
            <span className="unit"> %</span>
          </div>
        </div>
      )),
    ],
    ranking_volume: [
      createColumns("", "ranking-cell", (data: object) =>
        get(data, "Rank", "")
      ),
      createColumns("コード", "code-cell", (data: object) =>
        Formatter.symbol(data)
      ),
      createColumns("銘柄", "symbol-name-cell", (data: object) => (
        <div className="ellipsis-text">
          {get(data, "NameS", "") || get(data, "Name", "")}
        </div>
      )),
      createColumns("現在値", "currency-price-cell", (data: object) =>
        Formatter.number(get(data, "Price"), get(data, "NumberOfDecimals"))
      ),
      createColumns("出来高", "volume-cell", (row: object) =>
        Formatter.number(get(row, "TradVolume"))
      ),
    ],
    ranking_volumeSp: [
      createColumns("", "ranking-cell", (data: object) =>
        get(data, "Rank", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (data: object) => (
        <div>
          <div>{Formatter.symbol(data)}</div>
          <div className="ellipsis-text">
            {get(data, "NameS", "") || get(data, "Name", "")}
          </div>
        </div>
      )),
      createColumns("現在値", "currency-price-cell", (data: object) =>
        Formatter.number(get(data, "Price"), get(data, "NumberOfDecimals"))
      ),
      createColumns("出来高", "volume-cell", (row: object) =>
        Formatter.number(get(row, "TradVolume"))
      ),
    ],
    //TODO:今後使わなければ消す
    industryRanking: [
      createColumns("", "ranking-cell", () => "1"),
      createColumns("銘柄", "symbol-name-cell", () => (
        <div className="ellipsis-text">アシックス</div>
      )),
      createColumns("現在値", "currency-price-cell ", () => "1,353.0"),
      createColumns("前日比 (%)", "changed-ratio-cell", () => (
        <div className="liquid-row">
          <div className="change-price-value liquid-item up">+227.0</div>
          <div className="change-ratio-value liquid-item">
            (<span className="up">+20.16</span>
            <span className="unit">%</span>)
          </div>
        </div>
      )),
      createColumns("出来高", "volume-cell", () => "4,717,600"),
      createColumns("更新", "time-cell", () => "11:00"),
    ],
    domestic: {
      price: (
        isFull: boolean = false,
        isPhone: boolean = false,
        isVolumeIncrease: boolean = false
      ) =>
        concat(
          isFull
            ? RankingTableModels.detailSymbolArea
            : RankingTableModels.summarySymbolArea,
          RankingTableModels.rankingBase,
          isVolumeIncrease
            ? RankingTableModels.volumeIncrease
            : RankingTableModels.volume,
          isFull && !isPhone ? RankingTableModels.detailInfo : []
        ),
      priceIncreaseRate: (isFull: boolean = false, isPhone: boolean = false) =>
        concat(
          isFull
            ? RankingTableModels.detailSymbolArea
            : RankingTableModels.summarySymbolArea,
          RankingTableModels.rankingBase,
          isFull && !isPhone ? RankingTableModels.detailInfo : []
        ),
      trade: (
        isFull: boolean = false,
        isPhone: boolean = false,
        isVolumeIncrease: boolean = false,
        isPriceIncrease: boolean = false
      ) =>
        concat(
          isFull
            ? RankingTableModels.detailSymbolArea
            : RankingTableModels.summarySymbolArea,
          RankingTableModels.rankingBase,
          isPriceIncrease
            ? RankingTableModels.priceIncrease
            : RankingTableModels.price,
          isFull && !isPhone ? RankingTableModels.detailInfo : []
        ),
      trustRate: (isFull: boolean = false, isPhone: boolean = false) =>
        concat(
          isFull
            ? RankingTableModels.detailSymbolArea
            : RankingTableModels.summarySymbolArea,
          RankingTableModels.rankingBase,
          RankingTableModels.trustRate,
          isFull && !isPhone ? RankingTableModels.detailInfo : []
        ),
      trustBuy: (isFull: boolean = false, isPhone: boolean = false) =>
        concat(
          isFull
            ? RankingTableModels.detailSymbolArea
            : RankingTableModels.summarySymbolArea,
          RankingTableModels.rankingBase,
          RankingTableModels.trustBuy,
          isFull && !isPhone ? RankingTableModels.detailInfo : []
        ),
      trustSell: (isFull: boolean = false, isPhone: boolean = false) =>
        concat(
          isFull
            ? RankingTableModels.detailSymbolArea
            : RankingTableModels.summarySymbolArea,
          RankingTableModels.rankingBase,
          RankingTableModels.trustSell,
          isFull && !isPhone ? RankingTableModels.detailInfo : []
        ),
      marketPrice: (
        isFull: boolean = false,
        isPhone: boolean = false,
        isVolumeIncrease: boolean = false,
        isPriceIncrease: boolean = false
      ) =>
        concat(
          isFull
            ? RankingTableModels.detailSymbolArea
            : RankingTableModels.summarySymbolArea,
          RankingTableModels.rankingBase,
          isPriceIncrease
            ? RankingTableModels.priceIncrease
            : RankingTableModels.price,
          RankingTableModels.marketPrice
        ),
    },
  },
  data: {
    new: [
      createColumns("上場・変更日", "listing-date-cell", (row: object) =>
        Formatter.date(get(row, "PriceTime"), "YY/MM/DD")
      ),
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "SymbolName")}</span>
      )),
      createColumns("変更情報", "change-info-cell", (row: object) =>
        get(row, "SymbolName")
      ),
      createColumns("市場", "market-cell", (row: object) =>
        get(row, "SymbolName")
      ),
      createColumns("業種", "industry-cell", (row: object) =>
        get(row, "SymbolName")
      ),
    ],
    ipoDetail: (name: string) => [
      createColumns(name, "date-cell", (row: object) =>
        Formatter.date(String(get(row, "ApplyDayFrom")), "YY/MM/DD")
      ),
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns(
        "市場",
        "market-cell",
        (row: object) =>
          get(row, "ExchangeDivisions[0].ExchangeName") +
          get(row, "ExchangeDivisions[0].DivisionName")
      ),
      createColumns("業種", "industry-cell", (row: object) =>
        get(row, "JSecCodeName")
      ),
      createColumns("上場初値", "listing-price-cell", (row: object) => (
        <div className="liquid-row">
          <div className="currency-price-value liquid-item">
            {Formatter.number(
              get(row, "InitOpenPrice"),
              get(row, "NumberOfDecimals")
            )}
          </div>
          <div className="time-col liquid-item">
            {Formatter.date(get(row, "InitOpenDay"), "MM/DD HH:mm")}
          </div>
        </div>
      )),
      createColumns("公募価格", "public-price-cell", (row: object) => (
        <div className="liquid-row">
          <div className="currency-price-value liquid-item">
            {Formatter.number(
              get(row, "RecruitPrice"),
              get(row, "NumberOfDecimals")
            )}
          </div>
          <div className="time-col liquid-item">
            {Formatter.date(get(row, "PriceDicisionDate"), "MM/DD")}
          </div>
        </div>
      )),
      createColumns(
        "初値騰落率",
        "initial-changed-ratio-cell",
        (row: object) => {
          return (
            <div className="liquid-row">
              <div className="change-ratio-value liquid-item">
                <span
                  className={ClassNames(
                    Formatter.upDown(get(row, "InitOpenChangedRatio"))
                  )}
                >
                  {Formatter.number(get(row, "InitOpenChangedRatio"), 2)}
                </span>
                <span className="unit">%</span>
              </div>
            </div>
          )
        }
      ),
      createColumns("売買単位", "sellbuy-unit-cell", (row: object) =>
        get(row, "TradingUnit")
      ),
    ],
    ipoDetailSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
        (data: object) => {
          return (
            <div className="market-cell">
              {get(data, "ExchangeDivisions[0].ExchangeName") +
                get(data, "ExchangeDivisions[0].DivisionName")}
            </div>
          )
        },
      ],
      body: [
        {
          title: "公開日",
          value: (data: object) => {
            return (
              <span>
                {Formatter.date(String(get(data, "ApplyDayFrom")), "YY/MM/DD")}
              </span>
            )
          },
        },
        {
          title: "業種",
          value: (data: object) => {
            return <span>{get(data, "JSecCodeName")}</span>
          },
        },
        {
          title: "上場初値",
          value: (data: object) => {
            return (
              <div className="liquid-row">
                <div className="currency-price-value liquid-item">
                  {Formatter.number(
                    get(data, "InitOpenPrice"),
                    get(data, "NumberOfDecimals")
                  )}
                </div>
                <div className="time-col liquid-item">
                  {Formatter.date(get(data, "InitOpenDay"), "MM/DD HH:mm")}
                </div>
              </div>
            )
          },
        },
        {
          title: "公募価格",
          value: (data: object) => {
            return (
              <div className="liquid-row">
                <div className="currency-price-value liquid-item">
                  {Formatter.number(
                    get(data, "RecruitPrice"),
                    get(data, "NumberOfDecimals")
                  )}
                </div>
                <div className="time-col liquid-item">
                  {Formatter.date(get(data, "PriceDicisionDate"), "MM/DD")}
                </div>
              </div>
            )
          },
        },
        {
          title: "初値騰落率",
          value: (data: object) => {
            return (
              <div className="change-ratio-value liquid-item">
                <span
                  className={ClassNames(
                    Formatter.upDown(get(data, "InitOpenChangedRatio"))
                  )}
                >
                  {Formatter.number(get(data, "InitOpenChangedRatio"), 2)}
                </span>
                <span className="unit">%</span>
              </div>
            )
          },
        },
        {
          title: "売買単位",
          value: (data: object) => {
            return <span>{get(data, "TradingUnit")}</span>
          },
        },
      ],
    },
    additionalListingSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
      ],
      body: [
        {
          title: "上場日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {Formatter.date(String(get(data, "ApplyDayFrom")), "YY/MM/DD")}
              </span>
            )
          },
        },
        {
          title: "市場",
          value: (data: object) => {
            return (
              <span className="market-cell">
                {get(data, "ExchangeDivisions[0].ExchangeName") +
                  get(data, "ExchangeDivisions[0].DivisionName")}
              </span>
            )
          },
        },
        {
          title: "既存市場",
          value: (data: object) => {
            return (
              <span className="market-cell">
                {get(data, "ListedExchangeDivisions[0].ExchangeName") +
                  get(data, "ListedExchangeDivisions[0].DivisionName")}
              </span>
            )
          },
        },
        {
          title: "業種",
          value: (data: object) => {
            return (
              <span className="liquid-row">{get(data, "JSecCodeName")}</span>
            )
          },
        },
      ],
    },
    deListingSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
      ],
      body: [
        {
          title: "廃止予定日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {Formatter.date(String(get(data, "ApplyDayFrom")), "YY/MM/DD")}
              </span>
            )
          },
        },
        {
          title: "市場",
          value: (data: object) => {
            return (
              <span className="market-cell">
                {get(data, "ExchangeDivisions[0].ExchangeName") +
                  get(data, "ExchangeDivisions[0].DivisionName")}
              </span>
            )
          },
        },
        {
          title: "業種",
          value: (data: object) => {
            return (
              <span className="liquid-row">{get(data, "JSecCodeName")}</span>
            )
          },
        },
      ],
    },
    changeListingSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
      ],
      body: [
        {
          title: "変更日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {Formatter.date(String(get(data, "ApplyDayFrom")), "YY/MM/DD")}
              </span>
            )
          },
        },
        {
          title: "変更前市場",
          value: (data: object) => {
            return (
              <span className="market-cell">
                {get(data, "ExchangeDivisions[0].ExchangeName") +
                  get(data, "ExchangeDivisions[0].DivisionName")}
              </span>
            )
          },
        },
        {
          title: "変更後市場",
          value: (data: object) => {
            return (
              <span className="market-cell">
                {get(data, "NewJoujouBuName")}
              </span>
            )
          },
        },
        {
          title: "業種",
          value: (data: object) => {
            return (
              <span className="liquid-row">{get(data, "JSecCodeName")}</span>
            )
          },
        },
      ],
    },
    splitAllSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
      ],
      body: [
        {
          title: "権利落日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {Formatter.date(String(get(data, "ApplyDayFrom")), "YY/MM/DD")}
              </span>
            )
          },
        },
        {
          title: "種別",
          value: (data: object) => {
            return (
              <span className="type-cell">{get(data, "ChangedContents")}</span>
            )
          },
        },
        {
          title: "比率",
          value: (data: object) => {
            return (
              <span className="ratio-cell">{get(data, "WariateRitsu")}</span>
            )
          },
        },
      ],
    },
    splitSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
      ],
      body: [
        {
          title: "権利落日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {Formatter.date(String(get(data, "ApplyDayFrom")), "YY/MM/DD")}
              </span>
            )
          },
        },
        {
          title: "比率",
          value: (data: object) => {
            return (
              <span className="ratio-cell">{get(data, "WariateRitsu")}</span>
            )
          },
        },
      ],
    },
    openInfoAllSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
      ],
      body: [
        {
          title: "開始日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {!!get(data, "ApplyDayFrom")
                  ? Formatter.date(
                      String(get(data, "ApplyDayFrom")),
                      "YY/MM/DD"
                    )
                  : ""}
              </span>
            )
          },
        },
        {
          title: "種別",
          value: (data: object) => {
            return (
              <span className="ratio-cell">{get(data, "FinanceType")}</span>
            )
          },
        },
        {
          title: "株数/発行額",
          value: (data: object) => {
            return (
              <span className="payment-cell">
                {Formatter.number(
                  get(data, "IssuePrice"),
                  get(data, "NumberOfDecimals")
                )}
              </span>
            )
          },
        },
        {
          title: "価格決定日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {Formatter.date(
                  get(data, "FinancePriceDicisionDate", ""),
                  "YYYY/MM/DD"
                )}
              </span>
            )
          },
        },
        {
          title: "募集価格(円)",
          value: (data: object) => {
            return (
              <span className="payment-cell">
                {Formatter.fullPrecision(get(data, "RecruitPrice"))}
              </span>
            )
          },
        },
        {
          title: "期日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {!!get(data, "ApplyDayTo")
                  ? Formatter.date(
                      String(get(data, "ApplyDayTo", "")),
                      "YYYY/MM/DD"
                    )
                  : ""}
              </span>
            )
          },
        },
      ],
    },
    openInfoSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
      ],
      body: [
        {
          title: "開始日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {!!get(data, "ApplyDayFrom")
                  ? Formatter.date(
                      String(get(data, "ApplyDayFrom")),
                      "YY/MM/DD"
                    )
                  : ""}
              </span>
            )
          },
        },
        {
          title: "株数/発行額",
          value: (data: object) => {
            return (
              <span className="payment-cell">
                {Formatter.number(
                  get(data, "IssuePrice"),
                  get(data, "NumberOfDecimals")
                )}
              </span>
            )
          },
        },
        {
          title: "価格決定日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {Formatter.date(
                  get(data, "FinancePriceDicisionDate", ""),
                  "YYYY/MM/DD"
                )}
              </span>
            )
          },
        },
        {
          title: "募集価格(円)",
          value: (data: object) => {
            return (
              <span className="payment-cell">
                {Formatter.fullPrecision(get(data, "RecruitPrice"))}
              </span>
            )
          },
        },
        {
          title: "期日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {!!get(data, "ApplyDayTo")
                  ? Formatter.date(
                      String(get(data, "ApplyDayTo", "")),
                      "YYYY/MM/DD"
                    )
                  : ""}
              </span>
            )
          },
        },
      ],
    },
    mergeSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
      ],
      body: [
        {
          title: "合併期日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {isNull(get(data, "ApplyDayFrom"))
                  ? "-"
                  : Formatter.date(
                      String(get(data, "ApplyDayFrom")),
                      "YYYY/MM/DD"
                    )}
              </span>
            )
          },
        },
        {
          title: "被合併会社",
          value: (data: object) => {
            return (
              <div>
                <div className="">{get(data, "OldSymbol")}</div>
                <span className="symbol-name-cell">{get(data, "OldName")}</span>
              </div>
            )
          },
        },
        {
          title: "比率",
          value: (data: object) => {
            return (
              <span className="ratio-cell">
                {get(data, "GappeiHiritsu", "")}
              </span>
            )
          },
        },
        {
          title: "売買停止開始日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {isNull(get(data, "StopTradeDateFrom"))
                  ? "-"
                  : Formatter.date(
                      String(get(data, "StopTradeDateFrom", "")),
                      "YYYY/MM/DD"
                    )}
              </span>
            )
          },
        },
        {
          title: "売買停止終了日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {isNull(get(data, "StopTradeDateTo"))
                  ? "-"
                  : Formatter.date(
                      String(get(data, "StopTradeDateTo", "")),
                      "YYYY/MM/DD"
                    )}
              </span>
            )
          },
        },
      ],
    },
    changeSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
        (data: object) => {
          return (
            <div className="market-cell">
              {get(data, "ExchangeDivisions[0].ExchangeName", "") +
                get(data, "ExchangeDivisions[0].DivisionName", "")}
            </div>
          )
        },
      ],
      body: [
        {
          title: "交換・移転日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {isNull(get(data, "ApplyDayFrom"))
                  ? "-"
                  : Formatter.date(
                      String(get(data, "ApplyDayFrom")),
                      "YYYY/MM/DD"
                    )}
              </span>
            )
          },
        },
        {
          title: "完全子会社",
          value: (data: object) => {
            return (
              <div className="">
                <div>
                  <span>{get(data, "OldSymbol")}</span>
                  <span>
                    {get(data, "ListedExchangeDivisions[0].ExchangeName", "") +
                      get(data, "ListedExchangeDivisions[0].DivisionName", "")}
                  </span>
                </div>
                <span>{get(data, "OldName")}</span>
              </div>
            )
          },
        },
        {
          title: "比率",
          value: (data: object) => {
            return (
              <span className="ratio-cell">
                {get(data, "GappeiHiritsu", "")}
              </span>
            )
          },
        },
        {
          title: "売買停止開始日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {isNull(get(data, "StopTradeDateFrom"))
                  ? "-"
                  : Formatter.date(
                      String(get(data, "StopTradeDateFrom", "")),
                      "YYYY/MM/DD"
                    )}
              </span>
            )
          },
        },
        {
          title: "売買停止終了日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {isNull(get(data, "StopTradeDateTo"))
                  ? "-"
                  : Formatter.date(
                      String(get(data, "StopTradeDateTo", "")),
                      "YYYY/MM/DD"
                    )}
              </span>
            )
          },
        },
        {
          title: "区分",
          value: (data: object) => {
            return (
              <span className="type-cell">
                {get(data, "ChangedContents", "")}
              </span>
            )
          },
        },
      ],
    },
    brandSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
        (data: object) => {
          return (
            <div className="market-cell">
              {get(data, "ExchangeDivisions[0].ExchangeName", "-") +
                get(data, "ExchangeDivisions[0].DivisionName", "")}
            </div>
          )
        },
      ],
      body: [
        {
          title: "変更日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {isNull(get(data, "ApplyDayFrom"))
                  ? "-"
                  : Formatter.date(
                      String(get(data, "ApplyDayFrom")),
                      "YYYY/MM/DD"
                    )}
              </span>
            )
          },
        },
        {
          title: "変更前",
          value: (data: object) => {
            return (
              <span className="payment-cell">{get(data, "TradingUnit")}</span>
            )
          },
        },
        {
          title: "変更後",
          value: (data: object) => {
            return (
              <span className="payment-cell">
                {get(data, "NewTradingUnit")}
              </span>
            )
          },
        },
      ],
    },
    tradeNameSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
        (data: object) => {
          return (
            <div className="market-cell">
              {get(data, "ExchangeDivisions[0].ExchangeName", "-") +
                get(data, "ExchangeDivisions[0].DivisionName", "")}
            </div>
          )
        },
      ],
      body: [
        {
          title: "変更日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {isNull(get(data, "ApplyDayFrom"))
                  ? "-"
                  : Formatter.date(
                      String(get(data, "ApplyDayFrom")),
                      "YYYY/MM/DD"
                    )}
              </span>
            )
          },
        },
        {
          title: "新商号",
          value: (data: object) => {
            return (
              <span className="symbol-name-cell">{get(data, "NewName")}</span>
            )
          },
        },
      ],
    },
    stableSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
      ],
      body: [
        {
          title: "期間",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {`${Formatter.date(
                  String(get(data, "ApplyDayFrom")),
                  "YYYY/MM/DD"
                )} - ${Formatter.date(
                  String(get(data, "ApplyDayTo")),
                  "YYYY/MM/DD"
                )}`}
              </span>
            )
          },
        },
      ],
    },
    supervisionSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
        (data: object) => {
          return (
            <div className="market-cell">
              {get(data, "ExchangeDivisions[0].ExchangeName", "-") +
                get(data, "ExchangeDivisions[0].DivisionName", "")}
            </div>
          )
        },
      ],
      body: [
        {
          title: "指定日付",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {Formatter.date(String(get(data, "ApplyDayTo")), "YYYY/MM/DD")}
              </span>
            )
          },
        },
      ],
    },
    organizeSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return <div className="symbol-name-cell">{get(data, "Name")}</div>
        },
        (data: object) => {
          return (
            <div className="market-cell">
              {get(data, "ExchangeDivisions[0].ExchangeName", "-") +
                get(data, "ExchangeDivisions[0].DivisionName", "")}
            </div>
          )
        },
      ],
      body: [
        {
          title: "開始日",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {Formatter.date(
                  String(get(data, "ApplyDayFrom")),
                  "YYYY/MM/DD"
                )}
              </span>
            )
          },
        },
        {
          title: "指定日付",
          value: (data: object) => {
            return (
              <span className="date-cell">
                {Formatter.date(String(get(data, "ApplyDayTo")), "YYYY/MM/DD")}
              </span>
            )
          },
        },
      ],
    },
    additionalListing: (name: string) => [
      createColumns(name, "date-cell", (row: object) =>
        Formatter.date(String(get(row, "ApplyDayFrom")), "YYYY/MM/DD")
      ),
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns(
        "市場",
        "market-cell",
        (row: object) =>
          get(row, "ExchangeDivisions[0].ExchangeName") +
          get(row, "ExchangeDivisions[0].DivisionName")
      ),
      createColumns(
        "既存市場",
        "market-cell",
        (row: object) =>
          get(row, "ListedExchangeDivisions[0].ExchangeName") +
          get(row, "ListedExchangeDivisions[0].DivisionName")
      ),
      createColumns("業種", "industry-cell", (row: object) =>
        get(row, "JSecCodeName")
      ),
    ],
    deListing: (name: string) => [
      createColumns(name, "date-cell", (row: object) =>
        Formatter.date(String(get(row, "ApplyDayFrom")), "YYYY/MM/DD")
      ),
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns(
        "市場",
        "market-cell",
        (row: object) =>
          get(row, "ExchangeDivisions[0].ExchangeName") +
          get(row, "ExchangeDivisions[0].DivisionName")
      ),
      createColumns("業種", "industry-cell", (row: object) =>
        get(row, "JSecCodeName")
      ),
    ],
    changeListing: (name: string) => [
      createColumns(name, "date-cell", (row: object) =>
        Formatter.date(String(get(row, "ApplyDayFrom")), "YYYY/MM/DD")
      ),
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns(
        "変更前市場",
        "market-cell",
        (row: object) =>
          get(row, "ExchangeDivisions[0].ExchangeName") +
          get(row, "ExchangeDivisions[0].DivisionName")
      ),
      createColumns("変更後市場", "market-cell", (row: object) =>
        get(row, "NewJoujouBuName")
      ),
      createColumns("業種", "industry-cell", (row: object) =>
        get(row, "JSecCodeName")
      ),
    ],
    splitAll: [
      createColumns("権利落日", "date-cell", (row: object) =>
        Formatter.date(String(get(row, "ApplyDayFrom")), "YYYY/MM/DD")
      ),
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns("種別", "type-cell", (row: object) =>
        get(row, "ChangedContents")
      ),
      createColumns("比率", "ratio-cell", (row: object) =>
        get(row, "WariateRitsu")
      ),
    ],
    split: [
      createColumns("権利落日", "date-cell", (row: object) =>
        Formatter.date(String(get(row, "ApplyDayFrom")), "YYYY/MM/DD")
      ),
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns("比率", "ratio-cell", (row: object) =>
        get(row, "WariateRitsu")
      ),
    ],
    supervision: [
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns(
        "市場",
        "market-cell",
        (row: object) =>
          get(row, "ExchangeDivisions[0].ExchangeName") +
          get(row, "ExchangeDivisions[0].DivisionName")
      ),
      createColumns("指定日付", "date-cell", (row: object) =>
        Formatter.date(String(get(row, "ApplyDayFrom")), "YYYY/MM/DD")
      ),
    ],
    organize: [
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns(
        "市場",
        "market-cell",
        (row: object) =>
          get(row, "ExchangeDivisions[0].ExchangeName") +
          get(row, "ExchangeDivisions[0].DivisionName")
      ),
      createColumns("開始日", "date-cell", (row: object) =>
        Formatter.date(String(get(row, "ApplyDayFrom")), "YYYY/MM/DD")
      ),
      createColumns("終了日", "date-cell", (row: object) =>
        Formatter.date(String(get(row, "ApplyDayTo")), "YYYY/MM/DD")
      ),
    ],
    openInfoAll: [
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄名", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns("開始日", "date-cell", (row: object) =>
        !!get(row, "ApplyDayFrom")
          ? Formatter.date(String(get(row, "ApplyDayFrom", "")), "YYYY/MM/DD")
          : ""
      ),
      createColumns("種別", "type-cell", (row: object) =>
        get(row, "FinanceType")
      ),
      createColumns("株数/発行額", "payment-cell", (row: object) =>
        Formatter.number(get(row, "IssuePrice"), get(row, "NumberOfDecimals"))
      ),
      createColumns("価格決定日", "date-cell", (row: object) =>
        Formatter.date(get(row, "FinancePriceDicisionDate", ""), "YYYY/MM/DD")
      ),
      createColumns("募集価格(円)", "payment-cell", (row: object) =>
        Formatter.fullPrecision(get(row, "RecruitPrice"))
      ),
      createColumns("期日", "date-cell", (row: object) =>
        !!get(row, "ApplyDayTo")
          ? Formatter.date(String(get(row, "ApplyDayTo", "")), "YYYY/MM/DD")
          : ""
      ),
    ],
    openInfo: [
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄名", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns("開始日", "date-cell", (row: object) =>
        !!get(row, "ApplyDayFrom")
          ? Formatter.date(String(get(row, "ApplyDayFrom", "")), "YYYY/MM/DD")
          : ""
      ),
      createColumns("株数/発行額", "payment-cell", (row: object) =>
        Formatter.number(get(row, "IssuePrice"), get(row, "NumberOfDecimals"))
      ),
      createColumns("価格決定日", "date-cell", (row: object) =>
        Formatter.date(get(row, "FinancePriceDicisionDate", ""), "YYYY/MM/DD")
      ),
      createColumns("募集価格(円)", "payment-cell", (row: object) =>
        Formatter.fullPrecision(get(row, "RecruitPrice"))
      ),
      createColumns("期日", "date-cell", (row: object) =>
        !!get(row, "ApplyDayTo")
          ? Formatter.date(String(get(row, "ApplyDayTo", "")), "YYYY/MM/DD")
          : ""
      ),
    ],
    merge: [
      [
        {
          title: "合併期日",
          className: "date-cell",
          format: (row: object) =>
            isNull(get(row, "ApplyDayFrom"))
              ? "-"
              : Formatter.date(String(get(row, "ApplyDayFrom")), "YYYY/MM/DD"),
          row: 2,
          dataNum: 1,
        },
        {
          title: "合併会社",
          className: "",
          format: "",
          col: 2,
        },
        {
          title: "被合併会社",
          className: "",
          format: "",
          col: 2,
        },
        {
          title: "比率",
          className: "ratio-cell",
          format: (row: object) => get(row, "GappeiHiritsu", ""),
          row: 2,
          dataNum: 6,
        },
        {
          title: "売買停止期間",
          className: "",
          format: "",
          col: 2,
        },
      ],
      [
        {
          title: "コード",
          className: "code-cell",
          format: (row: object) => get(row, "Symbol"),
          dataNum: 2,
        },
        {
          title: "銘柄名",
          className: "symbol-name-cell",
          format: (row: object) => get(row, "Name"),
          dataNum: 3,
        },
        {
          title: "コード",
          className: "code-cell",
          format: (row: object) => get(row, "OldSymbol"),
          dataNum: 4,
        },
        {
          title: "銘柄名",
          className: "symbol-name-cell",
          format: (row: object) => get(row, "OldName"),
          dataNum: 5,
        },
        {
          title: "売買停止開始日",
          className: "date-cell",
          format: (row: object) =>
            isNull(get(row, "StopTradeDateFrom"))
              ? "-"
              : Formatter.date(
                  String(get(row, "StopTradeDateFrom", "")),
                  "YYYY/MM/DD"
                ),
          dataNum: 7,
        },
        {
          title: "売買停止終了日",
          className: "date-cell",
          format: (row: object) =>
            isNull(get(row, "StopTradeDateTo"))
              ? "-"
              : Formatter.date(
                  String(get(row, "StopTradeDateTo", "")),
                  "YYYY/MM/DD"
                ),
          dataNum: 8,
        },
      ],
    ],
    change: [
      [
        {
          title: "交換・移転日",
          className: "date-cell",
          format: (row: object) =>
            isNull(get(row, "ApplyDayFrom"))
              ? "-"
              : Formatter.date(String(get(row, "ApplyDayFrom")), "YYYY/MM/DD"),
          row: 2,
          dataNum: 1,
        },
        {
          title: "存続会社",
          className: "",
          format: "",
          col: 3,
        },
        {
          title: "完全子会社",
          className: "",
          format: "",
          col: 3,
        },
        {
          title: "比率",
          className: "ratio-cell",
          format: (row: object) => get(row, "GappeiHiritsu", ""),
          row: 2,
          dataNum: 8,
        },
        {
          title: "売買停止期間",
          className: "",
          format: "",
          col: 2,
        },
        {
          title: "区分",
          className: "type-cell",
          format: (row: object) => get(row, "ChangedContents", ""),
          row: 2,
          dataNum: 12,
        },
      ],
      [
        {
          title: "コード",
          className: "code-cell",
          format: (row: object) => get(row, "Symbol"),
          dataNum: 2,
        },
        {
          title: "銘柄名",
          className: "symbol-name-cell",
          format: (row: object) => get(row, "Name"),
          dataNum: 3,
        },
        {
          title: "市場",
          className: "market-cell",
          format: (row: object) =>
            get(row, "ExchangeDivisions[0].ExchangeName", "-") +
            get(row, "ExchangeDivisions[0].DivisionName", ""),
          dataNum: 4,
        },
        {
          title: "コード",
          className: "code-cell",
          format: (row: object) => get(row, "OldSymbol"),
          dataNum: 5,
        },
        {
          title: "銘柄名",
          className: "symbol-name-cell",
          format: (row: object) => get(row, "OldName"),
          dataNum: 6,
        },
        {
          title: "市場",
          className: "market-cell",
          format: (row: object) =>
            get(row, "ListedExchangeDivisions[0].ExchangeName", "-") +
            get(row, "ListedExchangeDivisions[0].DivisionName", ""),
          dataNum: 7,
        },
        {
          title: "売買停止開始日",
          className: "date-cell long",
          format: (row: object) =>
            isNull(get(row, "StopTradeDateFrom"))
              ? "-"
              : Formatter.date(
                  String(get(row, "StopTradeDateFrom", "")),
                  "YYYY/MM/DD"
                ),
          dataNum: 10,
        },
        {
          title: "売買停止終了日",
          className: "date-cell long",
          format: (row: object) =>
            isNull(get(row, "StopTradeDateTo"))
              ? "-"
              : Formatter.date(
                  String(get(row, "StopTradeDateTo", "")),
                  "YYYY/MM/DD"
                ),
          dataNum: 11,
        },
      ],
    ],
    brand: [
      createColumns("変更日", "date-cell", (row: object) =>
        Formatter.date(String(get(row, "ApplyDayFrom")), "YYYY/MM/DD")
      ),
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns(
        "市場",
        "market-cell",
        (row: object) =>
          get(row, "ExchangeDivisions[0].ExchangeName") +
          get(row, "ExchangeDivisions[0].DivisionName")
      ),
      createColumns("変更前", "payment-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "TradingUnit")}</span>
      )),
      createColumns("変更後", "payment-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "NewTradingUnit")}</span>
      )),
    ],
    tradeName: [
      createColumns("変更日", "date-cell", (row: object) =>
        Formatter.date(String(get(row, "ApplyDayFrom")), "YYYY/MM/DD")
      ),
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("旧商号", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns("新商号", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "NewName")}</span>
      )),
      createColumns(
        "市場",
        "market-cell",
        (row: object) =>
          get(row, "ExchangeDivisions[0].ExchangeName") +
          get(row, "ExchangeDivisions[0].DivisionName")
      ),
    ],
    stable: [
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "Name")}</span>
      )),
      createColumns(
        "期間",
        "date-cell",
        (row: object) =>
          `${Formatter.date(
            String(get(row, "ApplyDayFrom")),
            "YYYY/MM/DD"
          )} - ${Formatter.date(String(get(row, "ApplyDayTo")), "YYYY/MM/DD")}`
      ),
    ],
    etf: [
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <div>
          <span>{get(row, "Symbol", "")}</span>
          <span className="ellipsis-text">
            {get(row, "SymbolNameS", "") || get(row, "SymbolName", "")}
          </span>
        </div>
      )),
      createColumns("現在値", "currency-price-cell", (row: object) => (
        <div className="liquid-row">
          <div className="currency-price-value liquid-item">
            {Formatter.number(get(row, "Price"), get(row, "NumberOfDecimals"))}
          </div>
          <div className="time-col liquid-item">
            {Formatter.date(get(row, "PriceTime"), "MM/DD HH:mm")}
          </div>
        </div>
      )),
      createColumns("前日比 (%)", "changed-price-cell", (row: object) => {
        const changedPrice = new BigNumber(get(row, "Price"))
          .minus(get(row, "LastClose"))
          .toNumber()
        const changedRatio = calcChangedRatio({
          price: get(row, "Price"),
          lastClose: get(row, "LastClose"),
        })
        return (
          <div className="liquid-row">
            <div
              className={ClassNames(
                "change-price-value liquid-item",
                Formatter.upDown(changedPrice)
              )}
            >
              {Formatter.number(
                changedPrice,
                get(row, "NumberOfDecimals"),
                "floor",
                true
              )}
            </div>
            <div className="change-ratio-value liquid-item">
              (
              <span className={ClassNames(Formatter.upDown(changedRatio))}>
                {Formatter.number(changedRatio, 2, "floor", true)}
              </span>
              <span className="unit">%</span>)
            </div>
          </div>
        )
      }),
      createColumns("出来高", "volume-cell ", (data: object) =>
        Formatter.number(get(data, "TradVolume"))
      ),
    ],
    adr: [
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol", "")
      ),
      createColumns("銘柄名", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">
          {get(row, "SymbolNameS", "") || get(row, "SymbolName", "")}
        </span>
      )),
      createColumns("東京前日終値", "price-cell", (row: object) => (
        <div className="amount-row">
          <div className="currency-price-value">
            {Formatter.number(get(row, "LastClose"), 1)}
          </div>
        </div>
      )),
      createColumns("NY ADR終値", "price-cell", (row: object) => (
        <div className="liquid-row">
          <div className="currency-price-value liquid-item">
            {Formatter.number(get(row, "UsLastCloseJPY"), 1)}
          </div>
          <div className="time-col liquid-item">
            {Formatter.date(
              String(get(row, "UsLastCloseDay", "")),
              "YYYY/MM/DD"
            )}
          </div>
        </div>
      )),
      createColumns("NY-東京(円)", "price-cell", (row: object) => {
        const calcPrice = new BigNumber(get(row, "UsLastCloseJPY"))
          .minus(get(row, "LastClose"))
          .toNumber()
        return (
          <div className="amount-row">
            <div
              className={ClassNames(
                "currency-price-value",
                Formatter.upDown(calcPrice)
              )}
            >
              {Formatter.number(calcPrice, 1, "floor", true)}
            </div>
          </div>
        )
      }),
      createColumns("NY-東京(%)", "price-cell", (row: object) => {
        const calcRatio = calcChangedRatio({
          price: get(row, "UsLastCloseJPY"),
          lastClose: get(row, "LastClose"),
        })
        return (
          <div className="amount-row">
            <div
              className={ClassNames(
                "currency-price-value",
                Formatter.upDown(calcRatio)
              )}
            >
              {Formatter.number(calcRatio, 2, "floor", true)}
            </div>
          </div>
        )
      }),
    ],
    adrSp: {
      header: [
        (data: object) => {
          return <div className="code-cell">{get(data, "Symbol", "")}</div>
        },
        (data: object) => {
          return (
            <div className="symbol-name-cell">
              {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
            </div>
          )
        },
      ],
      body: [
        {
          title: "東京前日終値",
          value: (data: object) => {
            return (
              <div className="amount-row">
                <div className="currency-price-value">
                  {Formatter.number(get(data, "LastClose"), 1)}
                </div>
              </div>
            )
          },
        },
        {
          title: "NY ADR終値",
          value: (data: object) => {
            return (
              <div className="liquid-row">
                <div className="currency-price-value liquid-item">
                  {Formatter.number(get(data, "UsLastCloseJPY"), 1)}
                </div>
                <div className="time-col liquid-item">
                  {Formatter.date(
                    String(get(data, "UsLastCloseDay", "")),
                    "YYYY/MM/DD"
                  )}
                </div>
              </div>
            )
          },
        },
        {
          title: "NY-東京(円)",
          value: (data: object) => {
            const calcPrice = new BigNumber(get(data, "UsLastCloseJPY"))
              .minus(get(data, "LastClose"))
              .toNumber()

            return (
              <div className="amount-row">
                <div
                  className={ClassNames(
                    "currency-price-value",
                    Formatter.upDown(calcPrice)
                  )}
                >
                  {Formatter.number(calcPrice, 1, "floor", true)}
                </div>
              </div>
            )
          },
        },
        {
          title: "NY-東京(%)",
          value: (data: object) => {
            const calcRatio = calcChangedRatio({
              price: get(data, "UsLastCloseJPY"),
              lastClose: get(data, "LastClose"),
            })
            return (
              <div className="amount-row">
                <div
                  className={ClassNames(
                    "currency-price-value",
                    Formatter.upDown(calcRatio)
                  )}
                >
                  {Formatter.number(calcRatio, 2, "floor", true)}
                </div>
              </div>
            )
          },
        },
      ],
    },
  },
  trust: {
    negativeInterest: [
      createColumns("コード", "code-cell", (row: object) => get(row, "Symbol")),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "SymbolName")}</span>
      )),
      createColumns("品貸料", "negative-interest-cell", (row: object) =>
        Formatter.number(get(row, "GyakuHibu"), 2)
      ),
      createColumns("日数", "date-cell", (row: object) =>
        get(row, "HibuNissuu")
      ),
    ],
    shortage: [
      createColumns("コード", "code-cell", (row: object) => get(row, "Symbol")),
      createColumns("銘柄", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "SymbolName")}</span>
      )),
      createColumns("株不足", "shortage-cell", (row: object) => {
        const stockShortage = String(get(row, "StockShortage"))
        return Formatter.number(
          Number(stockShortage.replace("-", "")),
          0,
          "floor",
          false
        )
      }),
    ],
  },
  instrument: {
    top: [
      createColumns("商品", "title-cell", (data: object) => {
        return <span className="ellipsis-text">{get(data, "SymbolName")}</span>
      }),
      createColumns("現在値", "buy-sell-cell", (data: object) => {
        //金現物か銀現物の場合はPriceがnullであればLastClose,LastCloseTimeを使用する
        const [_price, _priceTime] = getPriceOrLastClose(data)
        const isGoldOrSilverSymbol = includes(
          [SECURITY_TYPE.XAU.id, SECURITY_TYPE.XAG.id],
          get(data, "SecurityType")
        )
        return (
          <div className="liquid-row">
            <div className="currency-price-value liquid-item">
              {Formatter.number(
                isGoldOrSilverSymbol ? _price : get(data, "Price"),
                get(data, "NumberOfDecimals")
              )}
            </div>
            <div className="time-col liquid-item">
              {Formatter.date(
                isGoldOrSilverSymbol ? _priceTime : get(data, "PriceTime"),
                "MM/DD HH:mm"
              )}
            </div>
          </div>
        )
      }),
      createColumns("前日比 (%)", "changed-price-cell", (data: object) => {
        const changedPrice = new BigNumber(get(data, "Price"))
          .minus(get(data, "LastClose"))
          .toNumber()
        const changedRatio = calcChangedRatio({
          price: get(data, "Price"),
          lastClose: get(data, "LastClose"),
        })
        return (
          <div className="liquid-row">
            <div
              className={ClassNames(
                "change-price-value liquid-item",
                Formatter.upDown(changedPrice)
              )}
            >
              {Formatter.number(
                changedPrice,
                get(data, "NumberOfDecimals"),
                "floor",
                true
              )}
            </div>
            <div className="change-ratio-value liquid-item">
              (
              <span className={ClassNames(Formatter.upDown(changedRatio))}>
                {Formatter.number(changedRatio, 2, "floor", true)}
              </span>
              <span className="unit">%</span>)
            </div>
          </div>
        )
      }),
    ],
  },
  bank_rate: {
    top: [
      createColumns("政策金利", "interest-title-cell", (data: object) => {
        const icon = getCountryIcon(data)
        return (
          <div className="index-name-row">
            <i className={ClassNames("icon-solid ", icon)} />
            <span className="index-name ellipsis-text">
              {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
            </span>
            <span className="group-cell-interest-rate">
              {get(data, "Price")}
            </span>
          </div>
        )
      }),
      //TODO:パネルサイズを半分にしたのでセルサイズ変更。問題なければコメント削除
      // createColumns("", "interest-rate-cell", (data: object) => {
      //   const numberOfDecimals = get(data, "NumberOfDecimals")
      //   return (
      //     <div className="change-price-value liquid-item">
      //       {Formatter.number(
      //         get(data, "Price"),
      //         isNull(numberOfDecimals) ? 2 : numberOfDecimals,
      //         "floor"
      //       )}
      //     </div>
      //   )
      // }),
      createColumns("実施年月日", "date-time-cell", (data: object) =>
        Formatter.date(get(data, "PriceTime"), "YYYY/MM/DD")
      ),
      //TODO:パネルサイズを半分にしたのでセルサイズ変更。問題なければコメント削除
      // createColumns("", "stretch-cell", () => ""),
    ],
    summary: [
      createColumns("政策金利", "interest-title-cell", (data: object) => {
        const icon = getCountryIcon(data)
        return (
          <div className="index-name-row">
            <i className={ClassNames("icon-solid ", icon)} />
            <span className="index-name ellipsis-text">
              {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
            </span>
            <span className="group-cell-interest-rate">
              {get(data, "Price")}
            </span>
          </div>
        )
      }),
      createColumns("実施年月日", "date-time-cell", (data: object) =>
        Formatter.date(get(data, "PriceTime"), "YYYY/MM/DD")
      ),
    ],
  },
  change: {
    listed: {
      today: [
        createColumns(
          () => <div className="liquid-row">本日公開</div>,
          "date-cell",
          (row: object) =>
            Formatter.date(String(get(row, "ApplyDayFrom")), "YY/MM/DD")
        ),
        createColumns("コード", "code-cell", (row: object) =>
          get(row, "Symbol", "")
        ),
        createColumns("銘柄", "symbol-name-cell", (row: object) => (
          <div className="ellipsis-text">{get(row, "Name")}</div>
        )),
        createColumns(
          "市場",
          "market-cell",
          (row: object) =>
            get(row, "ExchangeDivisions[0].ExchangeName") +
            get(row, "ExchangeDivisions[0].DivisionName")
        ),
      ],
      future: [
        createColumns(
          () => <div className="liquid-row">公開予定日</div>,
          "date-cell",
          (row: object) =>
            Formatter.date(String(get(row, "ApplyDayFrom")), "YY/MM/DD")
        ),
        createColumns("コード", "code-cell", (row: object) =>
          get(row, "Symbol", "")
        ),
        createColumns("銘柄", "symbol-name-cell", (row: object) => (
          <div className="ellipsis-text">{get(row, "Name")}</div>
        )),
        createColumns(
          "市場",
          "market-cell",
          (row: object) =>
            get(row, "ExchangeDivisions[0].ExchangeName") +
            get(row, "ExchangeDivisions[0].DivisionName")
        ),
      ],
      old: [
        createColumns(
          () => <div className="liquid-row">公開日</div>,
          "date-cell",
          (row: object) =>
            Formatter.date(String(get(row, "ApplyDayFrom")), "YY/MM/DD")
        ),
        createColumns("コード", "code-cell", (row: object) =>
          get(row, "Symbol", "")
        ),
        createColumns("銘柄", "symbol-name-cell", (row: object) => (
          <div className="ellipsis-text">{get(row, "Name")}</div>
        )),
        createColumns(
          "市場",
          "market-cell",
          (row: object) =>
            get(row, "ExchangeDivisions[0].ExchangeName") +
            get(row, "ExchangeDivisions[0].DivisionName")
        ),
      ],
    },
  },
  calendar: {
    summary: [
      createColumns("コード", "code-cell", (row: object) => get(row, "Symbol")),
      createColumns("銘柄名", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "SymbolName")}</span>
      )),
      createColumns("市場", "market-cell", (row: object) => {
        const securityType = get(row, "SecurityType")
        const exchange = get(row, "Exchange")
        return securityType === SECURITY_TYPE.Equity.id
          ? get(row, "ExchangeName") + get(row, "Exchange")
          : get(find(REGISTER_EXTENSION, { Exchange: exchange }), "extension")
      }),
      createColumns("業種", "industry-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "JSecCodeName")}</span>
      )),
    ],
    domestic: [
      createColumns("予定日", "date-cell", (row: object) =>
        Formatter.date(String(get(row, "AnnounceDate")), "YYYY/MM/DD")
      ),
      createColumns("コード", "code-cell", (row: object) => get(row, "Symbol")),
      createColumns("銘柄名", "symbol-name-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "SymbolName")}</span>
      )),
      createColumns(
        "市場",
        "market-cell",
        (row: object) => get(row, "ExchangeName") + get(row, "Exchange")
      ),
      createColumns("業種", "industry-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "JSecCodeName")}</span>
      )),
    ],
    foreign: [
      createColumns("国", "country-cell", (row: object) => {
        const icon = getCountryIcon(row)
        return <i className={ClassNames("icon-solid ", icon)} />
      }),
      createColumns("発表日", "date-cell", (row: object) =>
        Formatter.date(String(get(row, "CloseDay", "")), "YYYY/MM/DD")
      ),
      createColumns("コード", "code-cell", (row: object) =>
        Formatter.symbol(row)
      ),
      createColumns("銘柄名", "symbol-name-cell", (row: object) => (
        <div>
          <div className="code-market-group isSP">
            <span className="group-cell-code isSP">
              {get(row, "Symbol", "")}
            </span>
            <span className="market-cell isSP">
              {get(row, "ExchangeName", null)}
            </span>
          </div>
          <span className="ellipsis-text">{get(row, "SymbolNameS")}</span>
        </div>
      )),
      createColumns("市場", "market-cell", (data: object) => {
        const securityType = get(data, "SecurityType")
        const exchange = get(data, "Exchange")
        return securityType === SECURITY_TYPE.Equity.id
          ? Formatter.divisionName(data, true)
          : get(find(REGISTER_EXTENSION, { Exchange: exchange }), "extension")
      }),
      createColumns("業種", "industry-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "SPSecCodeName")}</span>
      )),
    ],
    foreignSp: [
      createColumns("国", "country-cell", (row: object) => {
        const icon = getCountryIcon(row)
        return <i className={ClassNames("icon-solid ", icon)} />
      }),
      createColumns("発表日", "date-cell", (row: object) =>
        Formatter.date(String(get(row, "CloseDay", "")), "YYYY/MM/DD")
      ),
      createColumns("コード", "code-cell", (row: object) =>
        Formatter.symbol(row)
      ),
      createColumns("銘柄名", "symbol-name-cell", (row: object) => {
        const securityType = get(row, "SecurityType")
        const exchange = get(row, "Exchange")

        return (
          <div>
            <div className="code-market-group isSP">
              <span className="group-cell-code isSP">
                {get(row, "Symbol", "")}
              </span>
              <span className="market-cell ellipsis-text isSP">
                {securityType === SECURITY_TYPE.Equity.id
                  ? Formatter.divisionName(row, true)
                  : get(
                      find(REGISTER_EXTENSION, { Exchange: exchange }),
                      "extension"
                    )}
              </span>
            </div>
            <span className="ellipsis-text">{get(row, "SymbolNameS")}</span>
          </div>
        )
      }),
      createColumns("市場", "market-cell", (data: object) => {
        const securityType = get(data, "SecurityType")
        const exchange = get(data, "Exchange")
        return securityType === SECURITY_TYPE.Equity.id
          ? Formatter.divisionName(data, true)
          : get(find(REGISTER_EXTENSION, { Exchange: exchange }), "extension")
      }),
    ],
    verticalCalendarDetails: [
      createColumns("コード", "code-cell", (row: object) => get(row, "Symbol")),
      createColumns("銘柄名", "symbol-name-cell", (row: object) => (
        <div>
          <span className="group-cell-code isSP">{get(row, "Symbol", "")}</span>
          <span className="ellipsis-text">{get(row, "SymbolName")}</span>
        </div>
      )),
      createColumns("市場", "market-cell", (row: object) =>
        get(row, "ExchangeName")
      ),
      createColumns("業種", "industry-cell", (row: object) => (
        <span className="ellipsis-text">{get(row, "JSecCodeName")}</span>
      )),
    ],
  },
  foreign: {
    index: [
      createColumns("指数・指標", "index-cell", (data: object) => {
        const icon = getCountryIcon(data)
        return (
          <div className="index-name-row">
            <i className={ClassNames("icon-solid ", icon)} />
            <span className="index-name ellipsis-text">
              {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
            </span>
          </div>
        )
      }),
      createColumns("現在値", "currency-price-cell", (data: object) => (
        <div className="amount-row">
          <div className="currency-price-value">
            {Formatter.number(
              get(data, "Price", null),
              get(data, "NumberOfDecimals")
            )}
          </div>
          <div className="time-col liquid-item">
            {Formatter.date(get(data, "PriceTime"), "MM/DD HH:mm")}
          </div>
        </div>
      )),
      createColumns("前日比 (%)", "changed-price-cell", (data: object) => {
        const changedPrice = new BigNumber(get(data, "Price"))
          .minus(get(data, "LastClose"))
          .toNumber()
        const changedRatio = calcChangedRatio({
          price: get(data, "Price"),
          lastClose: get(data, "LastClose"),
        })
        return (
          <div className="liquid-row">
            <div
              className={ClassNames(
                "change-price-value liquid-item",
                Formatter.upDown(changedPrice)
              )}
            >
              {Formatter.number(
                changedPrice,
                get(data, "NumberOfDecimals"),
                "floor",
                true
              )}
            </div>
            <div className="change-ratio-value liquid-item">
              (
              <span className={ClassNames(Formatter.upDown(changedRatio))}>
                {Formatter.number(changedRatio, 2, "floor", true)}
              </span>
              <span className="unit">%</span>)
            </div>
          </div>
        )
      }),
    ],
    currency: [
      createColumns("通貨", "currency-cell", (data: object) => (
        <div className="index-name-row">
          <div className="index-name ellipsis-text">
            {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
          </div>
        </div>
      )),
      createColumns("現在値", "buy-sell-cell", (row: object) => {
        const [_price, _priceTime] = getPriceOrLastClose(row)

        return (
          <div className="amount-row">
            <div className="currency-price-value ">
              {Formatter.number(_price, get(row, "NumberOfDecimals"))}
            </div>
            <div className="time-col liquid-item">
              {Formatter.date(_priceTime, "MM/DD HH:mm")}
            </div>
          </div>
        )
      }),
      createColumns("前日比 (%)", "changed-price-cell", (data: object) => {
        const changedPrice = new BigNumber(get(data, "Price"))
          .minus(get(data, "LastClose"))
          .toNumber()
        const changedRatio = calcChangedRatio({
          price: get(data, "Price"),
          lastClose: get(data, "LastClose"),
        })

        return (
          <div className="liquid-row">
            <div
              className={ClassNames(
                "change-price-value liquid-item",
                Formatter.upDown(changedPrice)
              )}
            >
              {Formatter.number(
                changedPrice,
                get(data, "NumberOfDecimals"),
                "floor",
                true
              )}
            </div>
            <div className={ClassNames("change-price-value liquid-item")}>
              (
              <span className={ClassNames(Formatter.upDown(changedRatio))}>
                {Formatter.number(changedRatio, 2, "floor", true)}
              </span>
              <span className="unit">%</span>)
            </div>
          </div>
        )
      }),
    ],
    interest: [
      createColumns("主要金利", "bank-cell", (data: object) => (
        <div className="index-name-row">
          <div className="index-name ellipsis-text">
            {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
          </div>
        </div>
      )),
      createColumns("利回り", "yield-cell", (data: object) => {
        const [_price, _priceTime] = getPriceOrLastClose(data)
        return (
          <div className="amount-row">
            <div className="currency-price-value">
              {Formatter.number(_price, get(data, "NumberOfDecimals"))}
            </div>
            <div className="time-col liquid-item">
              {Formatter.date(_priceTime, "MM/DD HH:mm")}
            </div>
          </div>
        )
      }),
      createColumns("利回比", "yield-ratio-cell", (data: object) => {
        const yieldRatio = new BigNumber(get(data, "Price"))
          .minus(get(data, "LastClose"))
          .toNumber()
        return (
          <div
            className={ClassNames(
              "change-price-value liquid-item",
              Formatter.upDown(yieldRatio)
            )}
          >
            {Formatter.number(
              yieldRatio,
              get(data, "NumberOfDecimals"),
              "floor",
              true
            )}
          </div>
        )
      }),
    ],
    list: [
      createColumns("コード", "code-cell", (data: object) =>
        Formatter.symbol(data)
      ),
      createColumns("銘柄", "symbol-name-cell", (data: object) => (
        <div className="ellipsis-text">
          {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
        </div>
      )),
      createColumns("現在値", "currency-price-cell", (data: object) => (
        <div className="amount-row">
          <div className="currency-price-value">
            {Formatter.number(
              get(data, "Price", null),
              get(data, "NumberOfDecimals")
            )}
          </div>
          <div className="time-col liquid-item">
            {Formatter.date(get(data, "PriceTime"), "HH:mm")}
          </div>
        </div>
      )),
      createColumns("前日比 (%)", "changed-ratio-cell", (data: object) => {
        return (
          <div className="liquid-row">
            <div
              className={ClassNames(
                "liquid-item change-price-value",
                Formatter.upDown(get(data, "ChangedPrice"))
              )}
            >
              {Formatter.number(get(data, "ChangedPrice"), 2, "floor", true)}
            </div>
            <div className="change-ratio-value liquid-item">
              (
              <span
                className={ClassNames(
                  Formatter.upDown(get(data, "ChangedRatio"))
                )}
              >
                {Formatter.number(get(data, "ChangedRatio"), 2, "floor", true)}
              </span>
              <span className="unit">%</span>)
            </div>
          </div>
        )
      }),
      createColumns("出来高", "volume-cell ", (data: object) =>
        Formatter.number(get(data, "TradVolume"))
      ),
    ],
    sp_list: [
      createColumns("銘柄", "symbol-name-cell", (data: object) => (
        <div>
          <div>{Formatter.symbol(data)}</div>
          <div className="ellipsis-text">
            {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
          </div>
        </div>
      )),
      createColumns("現在値", "currency-price-cell", (data: object) => (
        <div className="amount-row">
          <div className="currency-price-value">
            {Formatter.number(
              get(data, "Price", null),
              get(data, "NumberOfDecimals")
            )}
          </div>
          <div className="time-col liquid-item">
            {Formatter.date(get(data, "PriceTime"), "HH:mm")}
          </div>
        </div>
      )),
      createColumns("前日比 (%)", "changed-ratio-cell", (data: object) => {
        return (
          <div className="liquid-row">
            <div
              className={ClassNames(
                "liquid-item change-price-value",
                Formatter.upDown(get(data, "ChangedPrice"))
              )}
            >
              {Formatter.number(get(data, "ChangedPrice"), 2, "floor", true)}
            </div>
            <div className="change-ratio-value liquid-item">
              (
              <span
                className={ClassNames(
                  Formatter.upDown(get(data, "ChangedRatio"))
                )}
              >
                {Formatter.number(get(data, "ChangedRatio"), 2, "floor", true)}
              </span>
              <span className="unit">%</span>)
            </div>
          </div>
        )
      }),
    ],
  },
  tool: {
    detail: (selectFn: Function, state: DetailSearchStateType) => [
      createColumns("比較", "mark-cell", (data: object) => (
        <div className="mark-cell-item">
          <CheckBox
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              e.stopPropagation()
              selectFn(data)
            }}
            checked={checkHasSymbol(state.compare, data) !== null}
          />
        </div>
      )),
      createColumns("国", "country-cell", (data: APIResponse.Res) => (
        <i className={ClassNames("icon-solid", Formatter.icon(data))} />
      )),
      createColumns("コード", "code-cell", (data: object) =>
        Formatter.symbol(data)
      ),
      createColumns("銘柄名", "symbol-name-cell", (data: object) => (
        <span className="symbol-name">
          {get(data, "SymbolNameS") || get(data, "SymbolName")}
        </span>
      )),
      createColumns("市場", "market-cell", (data: object) => {
        const securityType = get(data, "SecurityType")
        const exchange = get(data, "Exchange")
        return securityType === SECURITY_TYPE.Equity.id
          ? Formatter.divisionName(data, true)
          : get(find(REGISTER_EXTENSION, { Exchange: exchange }), "extension")
      }),
      createColumns("業種", "market-cell", (data: object) =>
        get(data, "JSecCodeName")
      ),
      createColumns("業種(S&P)", "market-cell", (data: object) =>
        get(data, "SPSecCodeName")
      ),
      createColumns(
        (data: object) => {
          const sortType = get(data, "sortTarget.type")
          return sortType ? (
            <div className="sort-area">
              <span>時価総額</span>
              {sortType === "desc" && (
                <i className="material-icons sort-icon desc active">
                  play_arrow
                </i>
              )}
              {sortType === "asc" && (
                <i className="material-icons sort-icon asc active">
                  play_arrow
                </i>
              )}
            </div>
          ) : (
            <div className="sort-area">
              <span>時価総額</span>
              <i className="material-icons sort-icon desc">play_arrow</i>
              <i className="material-icons sort-icon asc">play_arrow</i>
            </div>
          )
        },
        "currency-price-cell sortable",
        (data: object) => (
          <>
            {Formatter.setNumber(data, "TotalMarketValue")}
            <span className="unit">百万</span>
          </>
        ),
        false,
        "TotalMarketValue"
      ),
      createColumns("現在値", "currency-price-cell", (row: object) => (
        <div className="liquid-row">
          <div className="currency-price-value liquid-item">
            {Formatter.number(get(row, "Price"), get(row, "NumberOfDecimals"))}
          </div>
          <div className="time-col liquid-item">
            {Formatter.date(get(row, "PriceTime"), "MM/DD HH:mm")}
          </div>
        </div>
      )),
    ],
    screening: {
      rsi: concat(ScreeningCommonParts, [
        createColumns("RSI", "ratio-cell", (data: object) => (
          <>
            {Formatter.number(get(data, "RSI"), 2)}
            <span className="unit">%</span>
          </>
        )),
        createColumns("ｻｲｺﾛｼﾞｶﾙﾗｲﾝ", "ratio-cell", (data: object) => (
          <>
            {Formatter.number(get(data, "Psychological"), 2)}
            <span className="unit">%</span>
          </>
        )),
        createColumns(
          () => (
            <>
              <span>ｽﾄｷｬｽﾃｨｸｽ</span>
              <span>9(%D)</span>
            </>
          ),
          "ratio-cell",
          (data: object) => (
            <>
              {Formatter.number(get(data, "STC"), 2)}
              <span className="unit">%</span>
            </>
          )
        ),
        createColumns(
          () => (
            <>
              <span>ｽﾄｷｬｽﾃｨｸｽ</span>
              <span>9(ｽﾛｰ%D)</span>
            </>
          ),
          "ratio-cell",
          (data: object) => (
            <>
              {Formatter.number(get(data, "SlowSTC"), 2)}
              <span className="unit">%</span>
            </>
          )
        ),
        createColumns("ﾎﾞﾘｭｰﾑﾚｼｵ", "ratio-cell", (data: object) => (
          <>
            {Formatter.number(get(data, "VolumeRatio"), 2)}
            <span className="unit">%</span>
          </>
        )),
      ]),
      average: concat(ScreeningCommonParts, [
        createColumns("5日移動平均乖離率", "ratio-cell", (data: object) => {
          const average = get(data, "MAER5")
          return (
            <>
              <div className={Formatter.upDown(average)}>
                {Formatter.number(average, 2, "floor", true)}
              </div>
              <span className="unit">%</span>
            </>
          )
        }),
        createColumns("25日移動平均乖離率", "ratio-cell", (data: object) => {
          const average = get(data, "MAER25")
          return (
            <>
              <div className={Formatter.upDown(average)}>
                {Formatter.number(average, 2, "floor", true)}
              </div>
              <span className="unit">%</span>
            </>
          )
        }),
        createColumns("13週移動平均乖離率", "ratio-cell", (data: object) => {
          const average = get(data, "MAER13W")
          return (
            <>
              <div className={Formatter.upDown(average)}>
                {Formatter.number(average, 2, "floor", true)}
              </div>
              <span className="unit">%</span>
            </>
          )
        }),
        createColumns("26週移動平均乖離率", "ratio-cell", (data: object) => {
          const average = get(data, "MAER26W")
          return (
            <>
              <div className={Formatter.upDown(average)}>
                {Formatter.number(average, 2, "floor", true)}
              </div>
              <span className="unit">%</span>
            </>
          )
        }),
        createColumns("信用倍率", "ratio-cell", (data: object) => (
          <>
            {Formatter.number(get(data, "MarginRatio"), 2)}
            <span className="unit">%</span>
          </>
        )),
      ]),
      total: concat(ScreeningCommonParts, [
        createColumns(
          (data: object) => {
            const sortType = get(data, "sortTarget.type")
            return sortType ? (
              <div className="sort-area">
                <span>時価総額(億円)</span>
                {sortType === "desc" && (
                  <i className="material-icons sort-icon desc active">
                    play_arrow
                  </i>
                )}
                {sortType === "asc" && (
                  <i className="material-icons sort-icon asc active">
                    play_arrow
                  </i>
                )}
              </div>
            ) : (
              <div className="sort-area">
                <span>時価総額(億円)</span>
                <i className="material-icons sort-icon desc">play_arrow</i>
                <i className="material-icons sort-icon asc">play_arrow</i>
              </div>
            )
          },
          "currency-price-cell sortable",
          (data: object) =>
            Formatter.number(get(data, "TotalMarketValueYen") / 100000000, 3),
          false,
          "TotalMarketValue"
        ),
        createColumns("PER", "ratio-cell", (data: object) => (
          <>
            {Formatter.number(get(data, "PER"), 2)}
            <span className="unit">倍</span>
          </>
        )),
        createColumns("PBR", "ratio-cell", (data: object) => (
          <>
            {Formatter.number(get(data, "PBR"), 2)}
            <span className="unit">倍</span>
          </>
        )),
        createColumns("配当利回り", "ratio-cell", (data: object) => (
          <>
            {Formatter.number(get(data, "DividendYield"), 2)}
            <span className="unit">%</span>
          </>
        )),
      ]),
    },
    benefit: [
      createColumns("画像", "image-cell", (data: object) => (
        <img src={get(data, "ImageUrl")} alt="" />
      )),
      createColumns("コード", "code-cell", (data: object) =>
        get(data, "Symbol")
      ),
      createColumns("銘柄名", "symbol-name-cell", (data: object) => (
        <span className="symbol-name ellipsis-text">
          {get(data, "SymbolNameS") || get(data, "SymbolName")}
        </span>
      )),
      createColumns("市場", "market-cell", (data: object) => {
        const securityType = get(data, "SecurityType")
        const exchange = get(data, "Exchange")
        return securityType === SECURITY_TYPE.Equity.id
          ? Formatter.divisionName(data, true)
          : get(find(REGISTER_EXTENSION, { Exchange: exchange }), "extension")
      }),
      createColumns("権利付最終日", "date-time-cell", (data: object) =>
        map(get(data, "RightAllotDayList", []), (date: string, i) => (
          <div key={i}>{Formatter.date(date, "YYYY/MM/DD")}</div>
        ))
      ),
      createColumns("権利確定月", "month-cell", (data: object) =>
        map(get(data, "RightFixMonthList", []), (date: string, i) => (
          <div key={i}>
            {currentBrowser === "chrome"
              ? Formatter.date(date, "M月")
              : `${date.replace("0", "")}月`}
          </div>
        ))
      ),
      createColumns("最低投資額", "price-cell", (data: object) =>
        Formatter.number(get(data, "NeededAmount"))
      ),
      createColumns("優待内容", "benefit-cell", (data: object) => {
        const [position, setPosition] = useState<[number, number]>()
        return (
          <div
            className="benefit-contents"
            onMouseEnter={e => {
              const clientRect = e.currentTarget.getBoundingClientRect()
              setPosition([
                clientRect.top + Number(e.currentTarget.clientHeight),
                clientRect.left,
              ])
            }}
            onMouseLeave={() => setPosition(null)}
          >
            <span className="benefit-txt">{get(data, "Content")}</span>
            <div
              className="btn btn-primary btn-shaped btn-more"
              onClick={() =>
                open_symbol_detail(
                  {
                    Symbol: get(data, "Symbol"),
                    Exchange: get(data, "Exchange"),
                    SecurityType: 1,
                  },
                  { tab: 6 }
                )
              }
            >
              優待内容詳細
            </div>
            <span className="benefit-more-mask" />
            {/*<ToolTip*/}
            {/*  name={!!position ? get(data, "Content") : null}*/}
            {/*  position={position}*/}
            {/*/>*/}
          </div>
        )
      }),
    ],
  },
  symbolDetail: {
    timeSale: [
      createColumns("時刻", "time-cell", (data: Array<string | number>) =>
        Formatter.date(toString(nth(data, 0)), "HH:mm:ss")
      ),
      createColumns("歩み値", "price-cell", (data: Array<string | number>) => (
        <span className={Formatter.upDown(nth(data, 5))}>
          {Formatter.number(nth(data, 2), toNumber(nth(data, -1)))}
        </span>
      )),
      createColumns("約出来", "yield-cell", (data: Array<string | number>) =>
        Formatter.number(nth(data, 3))
      ),
    ],
    performance: {
      dividend: [
        createColumns("決算期", "code-cell", (data: object) => {
          const isYosou = get(data, "YosouKubun")
          return isYosou
            ? `予想(${get(data, "KessanTsuki")}月期)`
            : `${get(data, "KessanNen")}年${get(data, "KessanTsuki")}月期`
        }),
        createColumns("配当", "symbol-cell number-cell", (data: object) => {
          const isForeign =
            get(data, "SecurityType") !== SECURITY_TYPE.Equity.id
          return (
            <>
              {get(data, "DPS")}
              <span
                className={ClassNames("unit unit-dividend", {
                  foreign: isForeign,
                })}
              >
                {get(data, "CurrencyCode", "")}
              </span>
            </>
          )
        }),
        createColumns("配当性向", "market-cell number-cell", (data: object) => (
          <>
            {Formatter.number(get(data, "HaitouSeikou"), 2)}
            <span className="unit unit-dividend">%</span>
          </>
        )),
        createColumns("純資産配当率", "currency-price-cell", (data: object) => (
          <>
            {Formatter.number(get(data, "HaitouJunShisanHiritsu"), 2)}
            <span className="unit unit-dividend">%</span>
          </>
        )),
      ],
    },
    capital: {
      capital: [
        createColumns("期日/異動日", "date-cell", (row: object) => {
          const type = get(row, "Type")
          const isFinance = type === 12
          return (
            Formatter.date(
              get(row, isFinance ? "ApplyDayTo" : ""),
              "YY/MM/DD"
            ) || "-"
          )
        }),
        createColumns("権利落日", "date-cell", (row: object) => {
          const type = get(row, "Type")
          const isFinance = type === 12
          const isCapital = type === 11 || type === 15
          return (
            Formatter.date(
              get(
                row,
                isCapital ? "ApplyDayFrom" : isFinance ? "" : "ApplyDayTo"
              ),
              "YY/MM/DD"
            ) || "-"
          )
        }),
        createColumns("種別", "type-cell", (row: object) => {
          const type = get(row, "Type")
          return getCapitalMovementsType(row, type)
        }),
        createColumns(
          "比率",
          "ratio-cell",
          (row: object) => get(row, "WariateRitsu") || "-"
        ),
        createColumns("払込金", "payment-cell", (row: object) =>
          Formatter.fullPrecision(get(row, "RecruitPrice"))
        ),
      ],
      capitalSp: {
        body: [
          {
            title: "期日/異動日",
            value: (row: object) => {
              const type = get(row, "Type")
              const isFinance = type === 12
              return (
                <div className="liquid-row">
                  <div className="liquid-item term-month-value">
                    {Formatter.date(
                      get(row, isFinance ? "ApplyDayTo" : ""),
                      "YY/MM/DD"
                    ) || "-"}
                  </div>
                </div>
              )
            },
          },
          {
            title: "権利落日",
            value: (row: object) => {
              const type = get(row, "Type")
              const isFinance = type === 12
              const isCapital = type === 11 || type === 15
              return (
                <div className="liquid-row">
                  <div className="liquid-item term-month-value">
                    {Formatter.date(
                      get(
                        row,
                        isCapital
                          ? "ApplyDayFrom"
                          : isFinance
                          ? ""
                          : "ApplyDayTo"
                      ),
                      "YY/MM/DD"
                    ) || "-"}
                  </div>
                </div>
              )
            },
          },
          {
            title: "種別",
            value: (row: object) => {
              const type = get(row, "Type")
              return (
                <div className="liquid-row">
                  <div className="liquid-item term-month-value">
                    {getCapitalMovementsType(row, type)}
                  </div>
                </div>
              )
            },
          },
          {
            title: "比率",
            value: (row: object) => {
              return (
                <div className="liquid-row">
                  <div className="liquid-item term-month-value">
                    {get(row, "WariateRitsu") || "-"}
                  </div>
                </div>
              )
            },
          },
          {
            title: "払込金",
            value: (row: object) => {
              return (
                <div className="liquid-row">
                  <div className="liquid-item term-month-value">
                    {Formatter.fullPrecision(get(row, "RecruitPrice"))}
                  </div>
                </div>
              )
            },
          },
        ],
      },

      move: [
        createColumns("異動日", "date-cell", (row: object) =>
          Formatter.date(get(row, "ApplyDayFrom"), "YY/MM/DD")
        ),
        createColumns("異動種別", "type-cell", (row: object) => {
          const type = get(row, "Type")
          return type === 17 ? "合併" : get(row, "ChangedContents")
        }),
        createColumns("子会社/被合併会社", "symbol-name-cell", (row: object) =>
          get(row, "OldName")
        ),
        createColumns("比率", "ratio-cell", (row: object) =>
          get(row, "GappeiHiritsu")
        ),
      ],
      moveSp: {
        body: [
          {
            title: "異動日",
            value: (row: object) => {
              return (
                <div className="liquid-row">
                  <div className="liquid-item term-month-value">
                    {Formatter.date(get(row, "ApplyDayFrom"), "YY/MM/DD")}
                  </div>
                </div>
              )
            },
          },
          {
            title: "異動種別",
            value: (row: object) => {
              const type = get(row, "Type")
              return (
                <div className="liquid-row">
                  <div className="liquid-item term-month-value">
                    {type === 17 ? "合併" : get(row, "ChangedContents")}
                  </div>
                </div>
              )
            },
          },
          {
            title: "子会社/被合併会社",
            value: (row: object) => {
              return (
                <div className="liquid-row">
                  <div className="liquid-item term-month-value">
                    {get(row, "OldName")}
                  </div>
                </div>
              )
            },
          },
          {
            title: "比率",
            value: (row: object) => {
              return (
                <div className="liquid-row">
                  <div className="liquid-item term-month-value">
                    {get(row, "GappeiHiritsu")}
                  </div>
                </div>
              )
            },
          },
        ],
      },
    },
    data: [
      createColumns("日付", "date-cell", (data: Array<string | number>) =>
        Formatter.date(toString(nth(data, 0)), "YYYY/MM/DD")
      ),
      createColumns("始値", "ohlc-cell", (data: Array<number>) =>
        Formatter.number(nth(data, 4), nth(data, -1))
      ),
      createColumns("高値", "ohlc-cell", (data: Array<number>) =>
        Formatter.number(nth(data, 2), nth(data, -1))
      ),
      createColumns("安値", "ohlc-cell", (data: Array<number>) =>
        Formatter.number(nth(data, 3), nth(data, -1))
      ),
      createColumns("終値", "ohlc-cell", (data: Array<number>) =>
        Formatter.number(nth(data, 5), nth(data, -1))
      ),
      createColumns("前日比", "ohlc-cell", (data: Array<number>) => (
        <span className={Formatter.upDown(nth(data, 9))}>
          {Formatter.number(nth(data, 9), nth(data, -1), "floor", true)}
        </span>
      )),
      createColumns("出来高", "volume-cell", (data: Array<number>) => (
        <>
          {Formatter.number(nth(data, 6))}
          <span className="unit">株</span>
        </>
      )),
    ],
    relation: (isPhone: boolean) =>
      !isPhone
        ? [
            createColumns("コード", "code-cell", (data: APIResponse.Res) =>
              get(data, "Symbol")
            ),
            createColumns(
              "銘柄名",
              "symbol-name-cell",
              (data: APIResponse.Res) => (
                <span className="ellipsis-text">
                  {get(data, "NameS") || get(data, "Name")}
                </span>
              )
            ),
            createColumns("市場", "market-cell", (data: APIResponse.Res) =>
              get(data, "ExchangeDivision")
            ),
            createColumns(
              "現在値",
              "currency-price-cell",
              (data: APIResponse.Res) => (
                <>
                  <div className="currency-price">
                    {Formatter.number(
                      get(data, "Price"),
                      get(data, "NumberOfDecimals")
                    )}
                  </div>
                  <div className="time-col">
                    {Formatter.date(get(data, "PriceTime"), "MM/DD HH:mm")}
                  </div>
                </>
              )
            ),
            createColumns(
              "時価総額(前日基準)",
              "currency-price-cell",
              (data: APIResponse.Res) => (
                <>
                  {Formatter.number(get(data, "TotalMarketValue") / 1000000, 0)}
                  <span className="unit">
                    百万{get(data, "CompanyCurrency")}
                  </span>
                </>
              )
            ),
          ]
        : [
            createColumns(
              "銘柄名",
              "symbol-name-cell",
              (data: APIResponse.Res) => (
                <div>
                  <span className="group-cell-code">
                    {get(data, "Symbol", "")}
                  </span>
                  <span className="ellipsis-text">
                    {get(data, "NameS", "") || get(data, "Name")}
                  </span>
                </div>
              )
            ),
            createColumns("市場", "market-cell", (data: APIResponse.Res) =>
              get(data, "ExchangeDivision")
            ),
            createColumns(
              "現在値",
              "currency-price-cell",
              (data: APIResponse.Res) => (
                <>
                  <div className="currency-price">
                    {Formatter.number(
                      get(data, "Price"),
                      get(data, "NumberOfDecimals")
                    )}
                  </div>
                  <div className="time-col">
                    {Formatter.date(get(data, "PriceTime"), "MM/DD HH:mm")}
                  </div>
                </>
              )
            ),
            createColumns(
              "時価総額(前日基準)",
              "currency-price-cell",
              (data: APIResponse.Res) => (
                <>
                  {Formatter.number(get(data, "TotalMarketValue") / 1000000, 0)}
                  <span className="unit">
                    百万{get(data, "CompanyCurrency")}
                  </span>
                </>
              )
            ),
          ],
  },
  utils: {
    search: [
      createColumns("コード", "code-cell", (data: object) =>
        Formatter.symbol(data)
      ),
      createColumns("銘柄", "symbol-name-cell", (data: object) => (
        <span className="ellipsis-text">
          {get(data, "SymbolNameS") || get(data, "SymbolName")}
        </span>
      )),
      createColumns("市場", "market-cell", (data: object) => {
        const securityType = get(data, "SecurityType")
        const exchange = get(data, "Exchange")
        return securityType === SECURITY_TYPE.Equity.id
          ? Formatter.divisionName(data, true)
          : get(find(REGISTER_EXTENSION, { Exchange: exchange }), "extension")
      }),
      createColumns("業種", "industry-cell", "JSecCodeName"),
    ],
    searchSp: [
      createColumns("銘柄", "symbol-name-cell", (data: object) => (
        <div>
          <span className="code-cell">{Formatter.symbol(data)}</span>
          <span className="ellipsis-text">
            {get(data, "SymbolNameS") || get(data, "SymbolName")}
          </span>
        </div>
      )),
      createColumns("市場", "market-cell", (data: object) => {
        const securityType = get(data, "SecurityType")
        const exchange = get(data, "Exchange")
        return securityType === SECURITY_TYPE.Equity.id
          ? Formatter.divisionName(data, true)
          : get(find(REGISTER_EXTENSION, { Exchange: exchange }), "extension")
      }),
      createColumns("業種", "industry-cell", "JSecCodeName"),
    ],
  },
}

export const infoTableColumns = {
  common_list: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell",
    list: [
      [
        {
          title: "始値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "OpenPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => {
            const _isHideParam = isHideParam(data)
            return (
              <span className="remarks">
                {_isHideParam
                  ? "-"
                  : `(${Formatter.date(get(data, "OpenPriceTime"), "HH:mm")})`}
              </span>
            )
          },
        },
        {
          title: "高値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "HighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => {
            const _isHideParam = isHideParam(data)
            return (
              <span className="remarks">
                {_isHideParam
                  ? "-"
                  : `(${Formatter.date(get(data, "HighPriceTime"), "HH:mm")})`}
              </span>
            )
          },
        },
        {
          title: "安値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => {
            const _isHideParam = isHideParam(data)
            return (
              <span className="remarks">
                {_isHideParam
                  ? "-"
                  : `(${Formatter.date(get(data, "LowPriceTime"), "HH:mm")})`}
              </span>
            )
          },
        },
        {
          title: "前終",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LastClose"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LastCloseTime"), "MM/DD")})
            </span>
          ),
        },
      ],
      [
        {
          title: "年初来高値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "YearlyHighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "YearlyHighDay"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "年初来安値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "YearlyLowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "YearlyLowDay"), "MM/DD")})
            </span>
          ),
        },

        {
          title: "5日移動平均",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "MA5"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "25日移動平均",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "MA25"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
      ],
    ],
  },
  sp_modal: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell",
    list: [
      [
        {
          title: "始値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "OpenPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "OpenPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "高値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "HighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "HighPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "安値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LowPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "前終",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LastClose"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LastCloseTime"), "MM/DD")})
            </span>
          ),
        },
      ],
    ],
  },
  sp_indicator_modal: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell",
    list: [
      [
        {
          title: "対象期",
          value: (data: APIResponse.Res) => (
            <span>{get(data, "DisplayTargetDate")}</span>
          ),
        },
        {
          title: "発表数値",
          value: (data: APIResponse.Res) => (
            <span>{get(data, "ActualText")}</span>
          ),
        },
        {
          title: "調査予想",
          value: (data: APIResponse.Res) => (
            <span>{get(data, "SurveyText")}</span>
          ),
        },
        {
          title: "前回数値",
          value: (data: APIResponse.Res) => (
            <span>{get(data, "RevisedPriorText")}</span>
          ),
        },
      ],
    ],
  },
  OP: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell",
    list: [
      [
        {
          title: "始値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "OpenPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "OpenPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "高値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "HighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "HighPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "安値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LowPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "前終",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LastClose"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LastCloseTime"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "出来高",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(get(data, "TradVolume"))}</span>
          ),
          unit: () => <span className="remarks">枚</span>,
        },
        {
          title: "売買代金",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.setNumber(data, "TradValue")}</span>
          ),
          unit: () => <span className="remarks">百万円</span>,
        },
      ],
      [
        {
          title: "更新回数",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(data.TickCount)}</span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "加重平均",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(data.VWAP, 4, "round")}</span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "上限値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "UpperLimitPrice"),
                get(data, "NumberOfDecimals"),
                "floor"
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "下限値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LowerLimitPrice"),
                get(data, "NumberOfDecimals"),
                "floor"
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "基準値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "StandardPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "限月高値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "ListedHighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "ListedHighDay"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "限月安値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "ListedLowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "ListedLowDay"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "建玉",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(data.Drv_TdyOpenIntst)}</span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "Drv_TdyOpenIntstDate"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "満期日",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.date(get(data, "SettlementDay"), "YYYY/MM/DD") || "-"}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
      ],
      [
        {
          title: "IV",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(data.Volatility, 2, "round")}</span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "デルタ",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(data.Delta, 4, "round")}</span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "ガンマ",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(data.Gamma, 6, "round")}</span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "ベガ",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(data.Vega, 4, "round")}</span>
          ),
          unit: () => <span className="remarks" />,
        },
      ],
    ],
  },
  future: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell",
    list: [
      [
        {
          title: "始値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "OpenPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "OpenPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "高値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "HighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "HighPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "安値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LowPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "前終",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LastClose"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LastCloseTime"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "限月高値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "ListedHighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "ListedHighDay"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "限月安値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "ListedLowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "ListedLowDay"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "建玉",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(data.Drv_TdyOpenIntst)}</span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "Drv_TdyOpenIntstDate"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "満期日",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.date(get(data, "SettlementDay"), "YYYY/MM/DD") || "-"}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
      ],
      [
        {
          title: "更新回数",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(data.TickCount)}</span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "加重平均",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(data.VWAP, 4, "round")}</span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "出来高",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.number(get(data, "TradVolume"))}</span>
          ),
          unit: () => <span className="remarks">枚</span>,
        },
        {
          title: "売買代金",
          value: (data: APIResponse.Res) => (
            <span>{Formatter.setNumber(data, "TradValue")}</span>
          ),
          unit: () => <span className="remarks">百万円</span>,
        },
        {
          title: "基準値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "StandardPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "上限値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "UpperLimitPrice"),
                get(data, "NumberOfDecimals"),
                "floor"
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "下限値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LowerLimitPrice"),
                get(data, "NumberOfDecimals"),
                "floor"
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
      ],
    ],
  },
  indexes: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell",
    list: [
      [
        {
          title: "始値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "OpenPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "OpenPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "高値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "HighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "HighPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "安値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LowPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "前終",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "LastClose"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LastCloseTime"), "MM/DD")})
            </span>
          ),
        },
      ],
      [
        {
          title: "年初来高値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "YearlyHighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "YearlyHighDay"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "年初来安値",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "YearlyLowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => (
            <span className="remarks">
              ({Formatter.date(get(data, "YearlyLowDay"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "5日移動平均",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "MA5"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "25日移動平均",
          value: (data: APIResponse.Res) => (
            <span>
              {Formatter.number(
                get(data, "MA25"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
      ],
    ],
  },
  price: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell",
    list: [
      [
        {
          title: "始値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "OpenPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks expand">
              ({Formatter.date(get(data, "OpenPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "高値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "HighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks expand">
              ({Formatter.date(get(data, "HighPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "安値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "LowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks expand">
              ({Formatter.date(get(data, "LowPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "前終",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "LastClose"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks expand">
              ({Formatter.date(get(data, "LastCloseTime"), "MM/DD")})
            </span>
          ),
        },
      ],
      [
        {
          title: "売気配",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "Ask"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks mini expand">
              ({Formatter.number(get(data, "AskVolume"), 0)})
            </span>
          ),
        },
        {
          title: "買気配",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "Bid"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks mini expand">
              ({Formatter.number(get(data, "BidVolume"), 0)})
            </span>
          ),
        },
        {
          title: "出来高",
          value: (data: object) => (
            <span>{Formatter.setNumber(data, "TradVolume")}</span>
          ),
          unit: () => <span className="remarks expand">万株</span>,
        },
        {
          title: "売買代金",
          value: (data: object) => (
            <span>{Formatter.number(get(data, "TradValue") / 1000)}</span>
          ),
          unit: () => <span className="remarks expand">千円</span>,
        },
      ],
    ],
  },
  symbol: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell ",
    list: [
      [
        {
          title: "始値",
          value: () => <span>21,201.83</span>,
          unit: () => <span className="unit unit-s">(09:00)</span>,
        },
        {
          title: "高値",
          value: () => <span>21,229.55</span>,
          unit: () => <span className="unit unit-s">(10:36)</span>,
        },
        {
          title: "安値",
          value: () => <span>21,145.81</span>,
          unit: () => <span className="unit unit-s">(09:20)</span>,
        },
        {
          title: "前終",
          value: () => <span>21,085.94</span>,
          unit: () => <span className="unit unit-s">(09/05)</span>,
        },
        {
          title: "出来高",
          value: () => <span>28,387</span>,
          unit: () => <span className="unit unit-s">万株</span>,
        },
      ],
    ],
  },
  indicative: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell",
    list: [
      [
        {
          title: "売気配",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "Ask"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks mini expand">
              ({Formatter.number(get(data, "AskVolume"), 0)})
            </span>
          ),
        },
        {
          title: "買気配",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "Bid"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks mini expand">
              ({Formatter.number(get(data, "BidVolume"), 0)})
            </span>
          ),
        },
        {
          title: "出来高",
          value: (data: object) => (
            <span>{Formatter.number(get(data, "TradVolume"))}</span>
          ),
          unit: () => <span className="remarks mini expand" />,
        },
      ],
      [
        {
          title: "始値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "OpenPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => {
            const _isHideParam = isHideParam(data)
            return (
              <span className="remarks expand">
                {_isHideParam
                  ? "-"
                  : `(${Formatter.date(get(data, "OpenPriceTime"), "HH:mm")})`}
              </span>
            )
          },
        },
        {
          title: "高値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "HighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => {
            const _isHideParam = isHideParam(data)
            return (
              <span className="remarks expand">
                {_isHideParam
                  ? "-"
                  : `(${Formatter.date(get(data, "HighPriceTime"), "HH:mm")})`}
              </span>
            )
          },
        },
        {
          title: "安値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "LowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: APIResponse.Res) => {
            const _isHideParam = isHideParam(data)
            return (
              <span className="remarks expand">
                {_isHideParam
                  ? "-"
                  : `(${Formatter.date(get(data, "LowPriceTime"), "HH:mm")})`}
              </span>
            )
          },
        },
        {
          title: "前終",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "LastClose"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks expand">
              ({Formatter.date(get(data, "LastCloseTime"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "売買代金",
          value: (data: object) => (
            <span>{Formatter.number(get(data, "TradValue") / 1000)}</span>
          ),
          unit: () => <span className="remarks expand">千円</span>,
        },
        {
          title: "売買単位",
          value: (data: object) => (
            <span>{Formatter.number(get(data, "TradingUnit"))}</span>
          ),
          unit: () => <span className="remarks expand">株</span>,
        },
      ],
    ],
  },
  foreign: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell",
    list: [
      [
        {
          title: "始値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "OpenPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "OpenPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "高値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "HighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "HighPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "安値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "LowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LowPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "前終",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "LastClose"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LastCloseTime"), "MM/DD")})
            </span>
          ),
        },
      ],
      [
        {
          title: "年初来高値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "YearlyHighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "YearlyHighDay"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "年初来安値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "YearlyLowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "YearlyLowDay"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "5日移動平均",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "MA5"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
        {
          title: "25日移動平均",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "MA25"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: () => <span className="remarks" />,
        },
      ],
    ],
  },
  heatMap: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell",
    list: [
      [
        {
          title: "始値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "OpenPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "OpenPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "高値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "HighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "HighPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "安値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "LowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LowPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "前終",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "LastClose"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LastCloseTime"), "MM/DD")})
            </span>
          ),
        },
      ],
    ],
  },
  compareSymbol: {
    titleCls: "title-cell",
    bodyCls: "index-detail-cell ",
    list: [
      [
        {
          title: "始値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "OpenPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "OpenPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "高値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "HighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "HighPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "安値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "LowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LowPriceTime"), "HH:mm")})
            </span>
          ),
        },
        {
          title: "終値",
          value: (data: object) => (
            <span>
              {Formatter.number(
                get(data, "LastClose"),
                get(data, "NumberOfDecimals")
              )}
            </span>
          ),
          unit: (data: object) => (
            <span className="remarks">
              ({Formatter.date(get(data, "LastCloseTime"), "MM/DD")})
            </span>
          ),
        },
        {
          title: "VWAP",
          value: (data: object) => (
            <span>{Formatter.number(get(data, "FirstVWAP"))}</span>
          ),
          unit: () => <span />,
        },
        {
          title: "出来高",
          value: (data: object) => (
            <span>{Formatter.number(get(data, "FirstTradVolume"))}</span>
          ),
          unit: () => <span className="unit unit-s">株</span>,
        },
      ],
    ],
  },
  symbolDetail: {
    detail: {
      before: {
        titleCls: "title-cell",
        bodyCls: "index-detail-cell number-cell",
        list: [
          [
            {
              title: "始値",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "FirstOpenPrice"),
                    get(data, "NumberOfDecimals", 0)
                  )}
                </span>
              ),
              unit: (data: object) => (
                <span className="time-col table-unit-space-time">
                  {Formatter.date(get(data, "FirstOpenPriceTime"), "HH:mm")}
                </span>
              ),
            },
            {
              title: "高値",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "FirstHighPrice"),
                    get(data, "NumberOfDecimals", 0)
                  )}
                </span>
              ),
              unit: (data: object) => (
                <span className="time-col table-unit-space-time">
                  {Formatter.date(get(data, "FirstHighPriceTime"), "HH:mm")}
                </span>
              ),
            },
            {
              title: "安値",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "FirstLowPrice"),
                    get(data, "NumberOfDecimals", 0)
                  )}
                </span>
              ),
              unit: (data: object) => (
                <span className="time-col table-unit-space-time">
                  {Formatter.date(get(data, "FirstLowPriceTime"), "HH:mm")}
                </span>
              ),
            },
            {
              title: "",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "FirstPrice"),
                    get(data, "NumberOfDecimals", 0)
                  )}
                </span>
              ),
              unit: (data: object) => (
                <span className="time-col table-unit-space-time">
                  {Formatter.date(get(data, "FirstPriceTime"), "HH:mm")}
                </span>
              ),
            },
            {
              title: "VWAP",
              value: (data: object) => (
                <span className="date-none">
                  {Formatter.number(get(data, "FirstVWAP"), 4)}
                </span>
              ),
              unit: () => <span />,
            },
            {
              title: "出来高",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "FirstTradVolume"))}</span>
              ),
              unit: () => (
                <span className="unit unit-s table-unit-space">株</span>
              ),
            },
          ],
        ],
      },
      after: {
        titleCls: "title-cell",
        bodyCls: "index-detail-cell number-cell",
        list: [
          [
            {
              title: "始値",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "SecondOpenPrice"),
                    get(data, "NumberOfDecimals", 0)
                  )}
                </span>
              ),
              unit: (data: object) => (
                <span className="time-col table-unit-space-time">
                  {Formatter.date(get(data, "SecondOpenPriceTime"), "HH:mm")}
                </span>
              ),
            },
            {
              title: "高値",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "SecondHighPrice"),
                    get(data, "NumberOfDecimals", 0)
                  )}
                </span>
              ),
              unit: (data: object) => (
                <span className="time-col table-unit-space-time">
                  {Formatter.date(get(data, "SecondHighPriceTime"), "HH:mm")}
                </span>
              ),
            },
            {
              title: "安値",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "SecondLowPrice"),
                    get(data, "NumberOfDecimals", 0)
                  )}
                </span>
              ),
              unit: (data: object) => (
                <span className="time-col table-unit-space-time">
                  {Formatter.date(get(data, "SecondLowPriceTime"), "HH:mm")}
                </span>
              ),
            },
            {
              title: "",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "SecondPrice"),
                    get(data, "NumberOfDecimals", 0)
                  )}
                </span>
              ),
              unit: (data: object) => (
                <span className="time-col table-unit-space-time">
                  {Formatter.date(get(data, "SecondPriceTime"), "HH:mm")}
                </span>
              ),
            },
            {
              title: "VWAP",
              value: (data: object) => (
                <span className="date-none">
                  {Formatter.number(get(data, "SecondVWAP"), 4)}
                </span>
              ),
              unit: () => <span />,
            },
            {
              title: "出来高",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "SecondTradVolume"))}</span>
              ),
              unit: () => (
                <span className="unit unit-s table-unit-space">株</span>
              ),
            },
          ],
        ],
      },
      unit: {
        titleCls: "title-cell",
        bodyCls: "index-detail-cell number-cell",
        list: [
          [
            {
              title: "時価総額",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "TotalMarketValue") / 1000000, 0)}
                </span>
              ),
              unit: (data: object) => (
                <span className="unit unit-s table-unit-space">
                  百万{get(data, "CompanyCurrency")}
                </span>
              ),
            },
            {
              title: "売買代金",
              value: (data: APIResponse.Res) => {
                return (
                  <span>
                    {Formatter.setNumber(data, "TradValue", {
                      decimals: 0,
                      digit: 1000,
                    })}
                  </span>
                )
              },
              unit: (data: APIResponse.Res) => (
                <span className="unit unit-s table-unit-space">
                  千{get(data, "CurrencyCode")}
                </span>
              ),
            },
            {
              title: "売買単位",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "TradingUnit"))}</span>
              ),
              unit: () => (
                <span className="unit unit-s table-unit-space">株</span>
              ),
            },
            {
              title: "制限値幅",
              value: (data: object) => (
                <span className="date-none">
                  {Formatter.number(
                    get(data, "LowerLimitPrice"),
                    get(data, "NumberOfDecimals", 0)
                  )}
                  ～
                  {Formatter.number(
                    get(data, "UpperLimitPrice"),
                    get(data, "NumberOfDecimals", 0)
                  )}
                </span>
              ),
              unit: () => <span />,
            },
            {
              title: "週間騰落率",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "ChangeRatioWeekly"), 2)}
                </span>
              ),
              unit: (data: object) => (
                <>
                  <span className="unit">%</span>
                  <span className="time-col table-unit-space-time rate">
                    {Formatter.date(
                      get(data, "ClosePriceWeekly.ClosePriceTime"),
                      "MM/DD"
                    )}
                  </span>
                </>
              ),
            },
            {
              title: "月間騰落率",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "ChangeRatioMonthly"), 2)}
                </span>
              ),
              unit: (data: object) => (
                <>
                  <span className="unit">%</span>
                  <span className="time-col table-unit-space-time rate">
                    {Formatter.date(
                      get(data, "ClosePriceMonthly.ClosePriceTime"),
                      "MM/DD"
                    )}
                  </span>
                </>
              ),
            },
          ],
        ],
      },
      info: {
        titleCls: "title-cell info",
        bodyCls: "index-detail-cell left-cell",
        list: [
          [
            {
              title: "ウェブサイト",
              value: (data: object) => {
                const url =
                  get(data, "SecurityType") === SECURITY_TYPE.Equity.id
                    ? get(data, "URL")
                    : "http://" + get(data, "URL")
                return (
                  <a
                    onClick={e => {
                      if (!!get(data, "URL")) {
                        e.preventDefault()
                        window.open(url)
                      }
                    }}
                  >
                    {!!get(data, "URL") ? url : "-"}
                  </a>
                )
              },
              unit: () => <span />,
            },
            {
              title: "正式名称",
              value: (data: object) => <span>{get(data, "Name")}</span>,
              unit: () => <span />,
            },
            {
              title: "会社概況",
              value: (data: object) => (
                <span>
                  {makeSentenceBreakList(data, "Description").map((str, i) => (
                    <div key={i}>{str}</div>
                  ))}
                </span>
              ),
              unit: () => <span />,
            },

            {
              title: "従業員数",
              value: (data: object) => (
                <div className="align-right">
                  <span>
                    {Formatter.number(get(data, "NumberOfEmployees"))}
                  </span>
                  <span className="unit">名</span>
                </div>
              ),
              unit: () => <span />,
            },
            {
              title: "代表者役職名",
              value: (data: object) => (
                <span>{get(data, "PresidentPosition")}</span>
              ),
              unit: () => <span />,
            },
            {
              title: "代表者氏名",
              value: (data: object) => {
                const createName = (data: object) => {
                  // 日本の場合、Delegateで値が返ってくるが、海外の場合、PresidentFirstName + PresidentMiddleName + PresidentLastNameで値を作成する
                  if (get(data, "SecurityType") === SECURITY_TYPE.Equity.id)
                    return get(data, "Delegate", "-")
                  // 海外の場合それぞれにnullが入っている可能性があるため、前にデータがあればスペース+値、なければ値のみを足していく。
                  let _data: string = null
                  const names = [
                    get(data, "PresidentFirstName"),
                    get(data, "PresidentMiddleName"),
                    get(data, "PresidentLastName"),
                  ]
                  forEach(names, items => {
                    if (!items) return
                    !_data ? (_data = items) : (_data += ` ${items}`)
                  })
                  return _data ? _data : "-"
                }
                const name = createName(data)
                return <span>{name}</span>
              },
              unit: () => <span />,
            },
            {
              title: "設立年",
              value: (data: object) => (
                <span>
                  {Formatter.date(get(data, "EstablishmentYear"), "YYYY")}
                </span>
              ),
              unit: () => <span />,
            },
            {
              title: "上場日",
              value: (data: object) => (
                <span>
                  {Formatter.date(get(data, "TradeDayFrom"), "YYYY/MM/DD")}
                </span>
              ),
              unit: () => <span />,
            },
            {
              title: "決算期",
              value: (data: object) => (
                <span>{Formatter.date(get(data, "CloseDay"), "M月")}</span>
              ),
              unit: () => <span />,
            },
            {
              title: "決算発表予定日時",
              value: (data: object) => {
                let announceDate = "-"
                if (get(data, "SettlementType") === 4)
                  announceDate = Formatter.date(
                    `${get(data, "AnnounceDate")}${get(data, "AnnounceTime")}`,
                    "YYYY/MM/DD HH:mm"
                  )
                return <span>{announceDate}</span>
              },
              unit: () => <span />,
            },
            {
              title: "発行済株式数",
              value: (data: object) => (
                <div className="align-right">
                  <span>{Formatter.number(get(data, "IssuedStocks"))}</span>
                  <span className="unit">株</span>
                </div>
              ),
              unit: () => <span />,
            },
            {
              title: "株式数更新日",
              value: (data: object) => (
                <span>
                  {Formatter.date(
                    get(data, "IssueStocksUpdateDate"),
                    "YYYY/MM/DD"
                  )}
                </span>
              ),
              unit: () => <span />,
            },
            {
              title: "浮動株数",
              value: (data: object) => (
                <div className="align-right">
                  <span>{Formatter.number(get(data, "FloatingShares"))}</span>
                  <span className="unit">株</span>
                </div>
              ),
              unit: () => <span />,
            },
            {
              title: "業種(東証33業種)",
              value: (data: object) => <span>{get(data, "JSecCodeName")}</span>,
              unit: () => <span />,
            },
            {
              title: "業種(S&P業種)",
              value: (data: object) => (
                <span>{get(data, "SPSecCodeName")}</span>
              ),
              unit: () => <span />,
            },
          ],
        ],
      },
      expect: {
        titleCls: "title-cell info performance-expectation",
        bodyCls: "index-detail-cell left-cell",
        list: [
          [
            {
              title: "予想EPS",
              value: (data: object) => (
                <div className="align-right">
                  <span>{Formatter.number(get(data, "E_EPS"), 2)}</span>
                  <span className="unit">{get(data, "CurrencyCode", "")}</span>
                </div>
              ),
              unit: () => <span />,
            },
            {
              title: "予想PER",
              value: (data: object) => (
                <div className="align-right">
                  <span>{Formatter.number(get(data, "E_PER"), 2)}</span>
                  <span className="unit">倍</span>
                </div>
              ),
              unit: () => <span />,
            },
            {
              title: "予想BPS",
              value: (data: object) => (
                <div className="align-right">
                  <span>{Formatter.number(get(data, "E_BPS"), 2)}</span>
                  <span className="unit">{get(data, "CurrencyCode", "")}</span>
                </div>
              ),
              unit: () => <span />,
            },
            {
              title: "予想配当利回り",
              value: (data: object) => (
                <div className="align-right">
                  <span>
                    {Formatter.number(get(data, "E_HaitouRimawari"), 2)}
                  </span>
                  <span className="unit">%</span>
                </div>
              ),
              unit: () => <span />,
            },
            {
              title: "配当落日",
              value: (data: object) => (
                <span>
                  {Formatter.date(get(data, "HaitouKenriOchiBi"), "YYYY/MM/DD")}
                </span>
              ),
              unit: () => <span />,
            },
          ],
        ],
      },
    },
    performance: {
      dividendDetail: {
        titleCls: "title-cell performance-dividend",
        bodyCls: "index-detail-cell number-cell",
        list: [
          [
            {
              title: "配当(実績)",
              value: (data: object) => <span>{get(data, "DPS")}</span>,
              unit: (data: object) => {
                const isForeign =
                  get(data, "SecurityType") !== SECURITY_TYPE.Equity.id
                return (
                  <span
                    className={ClassNames("unit unit-dividend", {
                      foreign: isForeign,
                    })}
                  >
                    {get(data, "CurrencyCode", "")}
                  </span>
                )
              },
            },
            {
              title: "配当(予想)",
              value: (data: object) => <span>{get(data, "YosouDPS")}</span>,
              unit: (data: object) => {
                const isForeign =
                  get(data, "SecurityType") !== SECURITY_TYPE.Equity.id
                return (
                  <span
                    className={ClassNames("unit unit-dividend", {
                      foreign: isForeign,
                    })}
                  >
                    {get(data, "CurrencyCode", "")}
                  </span>
                )
              },
            },
            {
              title: "配当日",
              value: (data: object) => (
                <span>
                  {Formatter.date(get(data, "HaitouShiharaiBi"), "YYYY/MM/DD")}
                </span>
              ),
              unit: () => <span />,
            },
            {
              title: "配当権利落日",
              value: (data: object) => (
                <span>
                  {Formatter.date(get(data, "HaitouKenriOchiBi"), "YYYY/MM/DD")}
                </span>
              ),
              unit: () => <span />,
            },
          ],
          [
            {
              title: "配当性向",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "HaitouSeikou"), 2)}</span>
              ),
              unit: () => <span className="unit unit-dividend">%</span>,
            },
            {
              title: "配当10年成長率",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "Haitou10NenSeichouRitsu"),
                    2,
                    "floor",
                    true
                  )}
                </span>
              ),
              unit: () => <span className="unit unit-dividend">%</span>,
            },
            {
              title: "配当5年成長率",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "Haitou5NenSeichouRitsu"),
                    2,
                    "floor",
                    true
                  )}
                </span>
              ),
              unit: () => <span className="unit unit-dividend">%</span>,
            },
            {
              title: "配当前年比",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "HaitouTaiZennenNobiritsu"),
                    2,
                    "floor",
                    true
                  )}
                </span>
              ),
              unit: () => <span className="unit unit-dividend">%</span>,
            },
          ],
        ],
      },
      inexpensive: {
        titleCls: "title-cell performance-capacity",
        bodyCls: "index-detail-cell number-cell",
        list: [
          [
            {
              title: "EV",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "EV"), 2)}</span>
              ),
              unit: (data: object) => (
                <span className="unit unit-capacity">{`百万${get(
                  data,
                  "CurrencyCode",
                  ""
                )}`}</span>
              ),
            },
            {
              title: "EBITDA",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "EBITDA"), 2)}</span>
              ),
              unit: (data: object) => (
                <span className="unit unit-capacity">{`百万${get(
                  data,
                  "CurrencyCode",
                  ""
                )}`}</span>
              ),
            },
            {
              title: "PER(実)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "R_PER"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">倍</span>,
            },
            {
              title: "PER(予)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "E_PER"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">倍</span>,
            },
            {
              title: "PBR(実)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "R_PBR"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">倍</span>,
            },
            {
              title: "PBR(予)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "E_PBR"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">倍</span>,
            },
          ],
        ],
      },
      safety: {
        titleCls: "title-cell performance-capacity",
        bodyCls: "index-detail-cell number-cell",
        list: [
          [
            {
              title: "BPS(実)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "R_BPS"), 2)}</span>
              ),
              unit: (data: object) => (
                <span className="unit unit-capacity">
                  {get(data, "CurrencyCode", "")}
                </span>
              ),
            },
            {
              title: "BPS(予)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "E_BPS"), 2)}</span>
              ),
              unit: (data: object) => (
                <span className="unit unit-capacity">
                  {get(data, "CurrencyCode", "")}
                </span>
              ),
            },
            {
              title: "自己資本比率",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "JikoShihonHiritsu"), 2)}
                </span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "負債比率",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "HusaiHiritsu"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "当座比率",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "TouzaHiritsu"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "流動比率",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "RyuudouHiritsu"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "株価キャッシュフロー倍率",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "KabukaCFBairitsu"), 2)}
                </span>
              ),
              unit: () => <span className="unit unit-capacity">倍</span>,
            },
            {
              title: "キャッシュフロー利回り",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "CFRimawari"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
          ],
        ],
      },
      profitability: {
        titleCls: "title-cell performance-capacity",
        bodyCls: "index-detail-cell number-cell",
        list: [
          [
            {
              title: "EPS(実)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "R_EPS"))}</span>
              ),
              unit: (data: object) => (
                <span className="unit unit-capacity">
                  {get(data, "CurrencyCode", "")}
                </span>
              ),
            },
            {
              title: "EPS(予)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "E_EPS"), 2)}</span>
              ),
              unit: (data: object) => (
                <span className="unit unit-capacity">
                  {get(data, "CurrencyCode", "")}
                </span>
              ),
            },
            {
              title: "ROE(実)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "R_ROE"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "ROE(予)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "E_ROE"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "ROA(実)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "R_ROA"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "ROA(予)",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "E_ROA"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "売上高営業利益率",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "UriagedakaEigyouRiekiRitsu"), 2)}
                </span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "過去5年最高純利益",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "KakoSaikouJunRieki"), 2)}
                </span>
              ),
              unit: (data: object) => (
                <span className="unit unit-capacity">{`百万${get(
                  data,
                  "CurrencyCode",
                  ""
                )}`}</span>
              ),
            },
            {
              title: "純利益率",
              value: (data: object) => (
                <span>{Formatter.number(get(data, "JunRiekiRitsu"), 2)}</span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "従業員1人当総売上高",
              value: (data: object) => {
                const targetData = get(data, "Juugyouin1RiAtariSouUriagedaka")
                return (
                  <span>
                    {Formatter.number(
                      isNull(targetData) ? targetData : targetData * 100
                    )}
                  </span>
                )
              },
              unit: (data: object) => (
                <span className="unit unit-capacity">{`万${get(
                  data,
                  "CurrencyCode",
                  ""
                )}`}</span>
              ),
            },
            {
              title: "従業員1人当純利益",
              value: (data: object) => {
                const targetData = get(data, "Juugyouin1RiAtariJunRieki")
                return (
                  <span>
                    {Formatter.number(
                      isNull(targetData) ? targetData : targetData * 100
                    )}
                  </span>
                )
              },
              unit: (data: object) => (
                <span className="unit unit-capacity">{`万${get(
                  data,
                  "CurrencyCode",
                  ""
                )}`}</span>
              ),
            },
            {
              title: "直近決算期益",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "ChokkinKessankiEkimawari"), 2)}
                </span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
          ],
        ],
      },
      growth: {
        titleCls: "title-cell performance-capacity",
        bodyCls: "index-detail-cell number-cell",
        list: [
          [
            {
              title: "EPS5年成長率",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "EPS5NenSeichouRitsu"), 2)}
                </span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "EPS対前年比伸び率",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "EPSTaiZennenHiNobiRitsu"), 2)}
                </span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "売上高成長率(予)",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "UriagedakaSeichouRitsu"), 2)}
                </span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "売上高 - 10年成長率",
              value: (data: object) => (
                <span>
                  {Formatter.number(
                    get(data, "Uriagedaka10NenSeichouRitsu"),
                    2
                  )}
                </span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "売上高 - 5年成長率",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "Uriagedaka5NenSeichouRitsu"), 2)}
                </span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
            {
              title: "経常利益成長率(予)",
              value: (data: object) => (
                <span>
                  {Formatter.number(get(data, "KeijouRiekiSeichouRitsu"), 2)}
                </span>
              ),
              unit: () => <span className="unit unit-capacity">%</span>,
            },
          ],
        ],
      },
    },
    stockBenefit: {
      info: {
        titleCls: "title-cell",
        bodyCls: "index-detail-cell number-cell",
        list: [
          [
            {
              title: "権利付き最終日",
              value: (data: APIResponse.Res) => {
                const lst = get(data, "RightAllotDayList")
                return map(lst, (row: number, i: number) => (
                  <div key={i}>{Formatter.date(String(row), "YYYY/MM/DD")}</div>
                ))
              },
              unit: () => "",
            },
            {
              title: "権利確定月",
              value: (data: APIResponse.Res) => {
                const lst = get(data, "RightFixMonthList")
                return map(lst, (row: number, i: number) => (
                  <span key={i}>
                    {`${row}月`}
                    {lst.length - 1 !== i ? "," : ""}
                  </span>
                ))
              },
              unit: () => "",
            },
            {
              title: "最低投資額(参考)",
              value: (data: APIResponse.Res) =>
                Formatter.number(get(data, "NeededAmount")),
              unit: () => <span className="unit">円</span>,
            },
          ],
        ],
      },
    },
  },
  regulationOther: {
    titleCls: "title-cell",
    bodyCls: "regulation-other-cell",
    list: [
      [
        {
          title: "売却のみ可",
          value: (data: object) => (
            <span>{get(data, "NotAvailable") === 1 ? "規制" : "-"}</span>
          ),
          unit: () => "",
        },
        {
          title: "ネット取引不可",
          value: (data: object) => (
            <span>{get(data, "NotNetAvailable") === 1 ? "規制" : "-"}</span>
          ),
          unit: () => "",
        },
        {
          title: "即日入金規制",
          value: (data: object) => (
            <span>{get(data, "SameDayDeposit") === 1 ? "規制" : "-"}</span>
          ),
          unit: () => "",
        },
      ],
      [
        {
          title: "安定操作可能期間",
          value: (data: object) => (
            <span>{get(data, "StableOperation") === 1 ? "規制" : "-"}</span>
          ),
          unit: () => "",
        },
        {
          title: "注意喚起",
          value: (data: object) => (
            <span>{get(data, "Attention") === 1 ? "規制" : "-"}</span>
          ),
          unit: () => "",
        },
        {
          title: "日々公表",
          value: (data: object) => (
            <span>{get(data, "PublishedDaily") === 1 ? "規制" : "-"}</span>
          ),
          unit: () => "",
        },
      ],
      [
        {
          title: "委託保証金率変更",
          value: (data: object) => (
            <span>{get(data, "ChangeMarginRate") === 1 ? "規制" : "-"}</span>
          ),
          unit: () => "",
        },
        {
          title: "品資料臨時借置",
          value: (data: object) => (
            <span>{get(data, "TemporaryRenting") === 1 ? "規制" : "-"}</span>
          ),
          unit: () => "",
        },

        {
          title: "公募・売出し",
          value: (data: object) => (
            <span>{get(data, "OfferSale") === 1 ? "規制" : "-"}</span>
          ),
          unit: () => "",
        },
      ],
    ],
  },
}

export const rowTable = {
  performance: {
    summary: [
      {
        title: "会予EPS(連)",
        value: "62.85",
        unit: "円",
      },
      {
        title: "会予PER(連)",
        value: "22.10",
        unit: "倍",
      },
      {
        title: "BPS(連)",
        value: "435.39",
        unit: "円",
      },
      {
        title: "配当利回り(会予)",
        value: "0.36",
        unit: "%",
      },
      {
        title: "配当落日",
        value: "2019/12/27",
        unit: "",
      },
    ],
  },
  detail: {
    sold: [
      {
        title: "売買単位",
        value: (data: APIResponse.Res) => get(data, "TradingUnit"),
        unit: "株",
      },
      {
        title: "制限値幅",
        value: (data: APIResponse.Res) =>
          `${Formatter.number(
            get(data, "LowerLimitPrice"),
            get(data, "NumberOfDecimals")
          )} - ${Formatter.number(
            get(data, "UpperLimitPrice"),
            get(data, "NumberOfDecimals")
          )}`,
        unit: "",
      },
      {
        title: "週間騰落率",
        value: () => (
          <>
            <span>1,186.0</span>
            <span className="up">
              +17.12<span className="unit">%</span>
            </span>
          </>
        ),
        unit: "10/18終値",
      },
      {
        title: "月間騰落率",
        value: () => (
          <>
            <span>1,198.0</span>
            <span className="up">
              +15.94<span className="unit">%</span>
            </span>
          </>
        ),
        unit: "09/26終値",
      },
    ],
    done: [
      {
        title: "年初来高値",
        value: (data: APIResponse.Res) => (
          <>
            <span>
              {Formatter.number(
                get(data, "YearlyHighPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
            <span className="down">
              -45.86<span className="unit">%</span>
            </span>
          </>
        ),
        unit: (data: APIResponse.Res) =>
          Formatter.date(get(data, "YearlyHighDay"), "MM/DD"),
      },
      {
        title: "年初来安値",
        value: (data: APIResponse.Res) => (
          <>
            <span>
              {Formatter.number(
                get(data, "YearlyLowPrice"),
                get(data, "NumberOfDecimals")
              )}
            </span>
            <span className="up">
              +28.38<span className="unit">%</span>
            </span>
          </>
        ),
        unit: (data: APIResponse.Res) =>
          Formatter.date(get(data, "YearlyLowDay"), "MM/DD"),
      },
      {
        title: "上場来高値",
        value: (data: APIResponse.Res) =>
          Formatter.number(
            get(data, "ListedHighPrice"),
            get(data, "NumberOfDecimals")
          ),
        unit: (data: APIResponse.Res) =>
          Formatter.date(get(data, "ListedHighDay"), "MM/DD"),
      },
      {
        title: "上場来安値",
        value: (data: APIResponse.Res) =>
          Formatter.number(
            get(data, "ListedLowPrice"),
            get(data, "NumberOfDecimals")
          ),
        unit: (data: APIResponse.Res) =>
          Formatter.date(get(data, "ListedLowDay"), "MM/DD"),
      },
      {
        title: "5日移動平均",
        value: () => (
          <>
            <span>1,186.4</span>
            <span className="up">
              +1.15<span className="unit">%</span>
            </span>
          </>
        ),
        unit: "",
      },
    ],
    index: [
      {
        title: "会予EPS(単)",
        value: "62.85",
        unit: "円",
      },
      {
        title: "コ予EPS(単)",
        value: "-",
        unit: "円",
      },
      {
        title: "会予PER(単)",
        value: "22.10",
        unit: "倍",
      },
      {
        title: "コ予PER(単)",
        value: "-",
        unit: "倍",
      },
      {
        title: "PBR(単)",
        value: "3.19",
        unit: "倍",
      },
      {
        title: "BPS(単)",
        value: "435.39",
        unit: "円",
      },
      {
        title: "時価総額",
        value: "4,563",
        unit: "百万円",
      },
    ],
    dividend: [
      {
        title: "年間配当(実)",
        value: "5",
        unit: "円",
      },
      {
        title: "配当利回り(会予)",
        value: "0.36",
        unit: "%",
      },
      {
        title: "配当利回り(コ予)",
        value: "-",
        unit: "%",
      },
      {
        title: "配当落日",
        value: "2019/12/27",
        unit: "",
      },
      {
        title: "発行済株式数",
        value: "3",
        unit: "百万株",
      },
    ],
  },
  session: [
    {
      title: "始値",
      value: "1,315.0",
      unit: "09:09",
    },
    {
      title: "高値",
      value: "1,500.0",
      unit: "09:37",
    },
    {
      title: "安値",
      value: "1,313.0",
      unit: "09:10",
    },
    {
      title: "終値",
      value: "1,389.0",
      unit: "11:30",
    },
    {
      title: "出来高",
      value: "159,500",
      unit: "",
    },
    {
      title: "VWAP",
      value: "1,436.6777",
      unit: "",
    },
  ],
  company: [
    {
      title: "東証33業種",
      value: "通信業",
    },
    {
      title: "トムソンロイター業種",
      value: "ソフトウェア",
    },
    {
      title: "会社概況",
      value:
        "トレードワークスグループは、証券システム開発事業と これらに付帯する外国為替証拠金取引（FX）システム事業及びセキュリティ診断事業を展開する。 証券システム事業において、同社は「Trade Agent」、「Athena」及び「Mars Web」を主力製品と位置づけ、 証券会社や金融情報システムサービス会社向けのシステムの開発・保守・運用を行う。FXシステム事業において、 同社は主にFX会社向けのシステムの開発・保守・運用を行い、パッケージ製品販売や請負開発、また、製品導入後の保守・運用サービスを行う。 セキュリティ診断事業いおいて、 同社は個人情報等の重要情報の漏えいや第三者からのシステムへの 不正侵入・不正操作の危険性を診断するサービスを提供する。",
      className: "description-cell",
    },
  ],
  credit: [
    {
      title: "品貸料",
      value: (data: APIResponse.Res) => {
        return (
          <div className="value-cell">
            <span>{get(data, "GyakuHibu") || "-"}</span>
            <span className="unit">円</span>
          </div>
        )
      },
    },
    {
      title: "回転日数",
      value: (data: APIResponse.Res) => {
        return (
          <div className="value-cell">
            <span>{get(data, "KaitenNissuu")}</span>
            <span className="unit">日</span>
          </div>
        )
      },
    },
    {
      title: "貸借倍率",
      value: (data: APIResponse.Res) => {
        return (
          <div className="value-cell">
            <span>{Formatter.number(get(data, "TaishakuBairitsu"), 2)}</span>
            <span className="unit">倍</span>
          </div>
        )
      },
    },
  ],
}

const color = [
  "heat-map-down-lv5",
  "heat-map-down-lv4",
  "heat-map-down-lv3",
  "heat-map-down-lv2",
  "heat-map-down-lv1",
  "heat-map-equal",
  "heat-map-up-lv1",
  "heat-map-up-lv2",
  "heat-map-up-lv3",
  "heat-map-up-lv4",
  "heat-map-up-lv5",
]

export const judgeHeatMapColor = (n: number) => {
  let cls: string
  if (!n || n === INT_MINI) {
    cls = color[5]
  } else if (n > 8) {
    cls = color[10]
  } else if (n > 6) {
    cls = color[9]
  } else if (n > 4) {
    cls = color[8]
  } else if (n > 2) {
    cls = color[7]
  } else if (n > 0) {
    cls = color[6]
  } else if (n === 0) {
    cls = color[5]
  } else if (n < 0) {
    cls = color[4]
  } else if (n < -2) {
    cls = color[3]
  } else if (n < -4) {
    cls = color[2]
  } else if (n < -6) {
    cls = color[1]
  } else if (n < -8) {
    cls = color[0]
  }
  return cls
}

const NikkeiMeigaraTitle = [
  "1-33銘柄",
  "34-66銘柄",
  "67-99銘柄",
  "100-132銘柄",
  "133-165銘柄",
  "166-198銘柄",
  "199-225銘柄",
]
export const HeatMapTableList = () =>
  NikkeiMeigaraTitle.map(title =>
    createColumns(
      title,
      (row: object) => judgeHeatMapColor(get(row, "ChangedRatio")),
      (row: object) => get(row, "SymbolNameS", "") || get(row, "SymbolName", "")
    )
  )

export type TrustTableColumnTitleType = {
  id: string
  name: string
  cls?: string
  isHeader?: boolean
}

export type TrustTableColumnListType = {
  title: Array<TrustTableColumnTitleType>
  titleCls?: string
  list: Array<{
    columnCls?: string
    row: {
      [t: string]: {
        content: Function
        cls?: string
      }
    }
  }>
}

export type TrustTableColumnType = {
  [t: string]: TrustTableColumnListType
}

export const trustTableColumns: TrustTableColumnType = {
  base: {
    title: [
      { id: "title", name: "", cls: "", isHeader: true },
      { id: "new", name: "新規", cls: "" },
      { id: "return", name: "返済", cls: "" },
      { id: "balance", name: "残高", cls: "" },
      { id: "subtraction", name: "差引", cls: "" },
      { id: "days", name: "回転日数", cls: "" },
    ],
    titleCls: "vertical-title-cell",
    list: [
      {
        columnCls: "vertical-value-cell",
        row: {
          title: { content: () => "貸株", cls: "" },
          new: { content: (data: number) => Formatter.number(data), cls: "" },
          return: {
            content: (data: number) => Formatter.number(data),
            cls: "",
          },
          balance: {
            content: (data: number) => Formatter.number(data),
            cls: "",
          },
          subtraction: {
            content: (data: number) => (
              <div
                className={ClassNames(
                  "change-price-value liquid-item",
                  Formatter.upDown(data)
                )}
              >
                {Formatter.number(data)}
              </div>
            ),
            cls: "",
          },
          days: {
            content: (data: number) => Formatter.number(data, 1),
            cls: "",
          },
        },
      },
      {
        columnCls: "vertical-value-cell",
        row: {
          title: { content: () => "融資", cls: "" },
          new: { content: (data: number) => Formatter.number(data), cls: "" },
          return: {
            content: (data: number) => Formatter.number(data),
            cls: "",
          },
          balance: {
            content: (data: number) => Formatter.number(data),
            cls: "",
          },
          subtraction: {
            content: (data: number) => (
              <div
                className={ClassNames(
                  "change-price-value liquid-item",
                  Formatter.upDown(data)
                )}
              >
                {Formatter.number(data)}
              </div>
            ),
            cls: "",
          },
          days: { content: () => "", cls: "" },
        },
      },
    ],
  },
  lendingOrLoanBase: {
    title: [
      { id: "title", name: "", cls: "", isHeader: true },
      { id: "new", name: "新規", cls: "" },
      { id: "return", name: "返済", cls: "" },
      { id: "balance", name: "残高", cls: "" },
      { id: "lendingOrLoanSubtraction", name: "差引", cls: "" },
      { id: "days", name: "回転日数", cls: "" },
    ],
    titleCls: "vertical-title-cell",
    list: [
      {
        columnCls: "vertical-value-cell",
        row: {
          title: { content: () => "貸株", cls: "" },
          new: { content: (data: number) => Formatter.number(data), cls: "" },
          return: {
            content: (data: number) => Formatter.number(data),
            cls: "",
          },
          balance: {
            content: (data: number) => Formatter.number(data),
            cls: "",
          },
          lendingOrLoanSubtraction: {
            content: (data: number) => (
              <div
                className={ClassNames(
                  "change-price-value liquid-item",
                  Formatter.upDown(data)
                )}
              >
                {Formatter.number(data)}
              </div>
            ),
            cls: "",
          },
          days: {
            content: (data: number) => Formatter.number(data, 1),
            cls: "",
          },
        },
      },
      {
        columnCls: "vertical-value-cell",
        row: {
          title: { content: () => "融資", cls: "" },
          new: { content: (data: number) => Formatter.number(data), cls: "" },
          return: {
            content: (data: number) => Formatter.number(data),
            cls: "",
          },
          balance: {
            content: (data: number) => Formatter.number(data),
            cls: "",
          },
          lendingOrLoanSubtraction: {
            content: (data: number) => (
              <div
                className={ClassNames(
                  "change-price-value liquid-item",
                  Formatter.upDown(data)
                )}
              >
                {Formatter.number(data)}
              </div>
            ),
            cls: "",
          },
          days: { content: () => "", cls: "" },
        },
      },
    ],
  },
  summary: {
    title: [
      { id: "title", name: "", cls: "", isHeader: true },
      { id: "rate", name: "貸借比率", cls: "" },
      { id: "shortage", name: "株不足", cls: "" },
      { id: "buy", name: "買申し込み", cls: "" },
      { id: "sell", name: "売申し込み", cls: "" },
    ],
    titleCls: "vertical-title-cell",
    list: [
      {
        columnCls: "vertical-value-cell",
        row: {
          title: { content: () => "貸株", cls: "" },
          rate: {
            content: (data: number) => Formatter.number(data, 2),
            cls: "",
          },
          shortage: {
            content: (data: number) => Formatter.number(data),
            cls: "",
          },
          buy: { content: (data: number) => Formatter.number(data), cls: "" },
          sell: { content: (data: number) => Formatter.number(data), cls: "" },
        },
      },
    ],
  },
  lending: {
    title: [
      { id: "title", name: "", cls: "", isHeader: true },
      { id: "price", name: "貸借値段", cls: "" },
      { id: "rate", name: "貸借比率", cls: "" },
      { id: "negative", name: "品貸料", cls: "" },
      { id: "shortage", name: "株不足", cls: "" },
    ],
    titleCls: "vertical-title-cell",
    list: [
      {
        columnCls: "vertical-value-cell",
        row: {
          title: { content: () => "", cls: "" },
          price: {
            content: (data: number) => Formatter.number(data, 1),
            cls: "",
          },
          rate: {
            content: (data: number) => Formatter.number(data, 2),
            cls: "",
          },
          negative: {
            content: (data: number) => Formatter.number(data, 2),
            cls: "",
          },
          shortage: {
            content: (data: number) => Formatter.number(data),
            cls: "",
          },
        },
      },
    ],
  },
  order: {
    title: [
      { id: "title", name: "", cls: "", isHeader: true },
      { id: "buy", name: "買申し込み", cls: "" },
      { id: "sell", name: "売申し込み", cls: "" },
    ],
    titleCls: "vertical-title-cell",
    list: [
      {
        columnCls: "vertical-value-cell",
        row: {
          title: { content: () => "", cls: "" },
          buy: { content: (data: number) => Formatter.number(data), cls: "" },
          sell: { content: (data: number) => Formatter.number(data), cls: "" },
        },
      },
    ],
  },
}

export const filterColumns = {
  ranking: ["code-cell"],
  settlement: ["code-cell"],
  settlementForeign: ["code-cell", "market-cell"],
}
